// challenges
//
// Purpose: Challenge and event preset categories
//
// This module:
// - Exports preset categories: UnBox Drums, Weekly Challenges, CoolTasDude

import { toNameMap } from "../../../synth/synth-config";
import type { InputPresetCategory } from "./types";

export const challengeCategories: InputPresetCategory[] = [
	{
		name: "UnBox Drums",
		presets: toNameMap([]),
	},
	{
		name: "Mid's Weekly Challenges",
		presets: toNameMap([
			{
				name: "Chocolate Pulse",
				generalMidi: false,
				tags: ["pwm", "retro"],
				settings: {
					type: "PWM",
					eqFilter: [{ type: "high-pass", cutoffHz: 176.78, linearGain: 0.7071 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [{ type: "high-pass", cutoffHz: 176.78, linearGain: 0.7071 }],
					effects: ["vibrato", "chorus", "echo", "reverb"],
					vibrato: "custom",
					vibratoDepth: 0.64,
					vibratoDelay: 19,
					vibratoSpeed: 30,
					vibratoType: 0,
					panDelay: 10,
					chorus: 29,
					echoSustain: 43,
					echoDelayBeats: 1,
					reverb: 3,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					pulseWidth: 50,
					decimalOffset: 86,
					unison: "none",
					envelopes: [{ target: "vibratoDepth", envelope: "swell 3" }],
				},
			},
			{
				name: "Chocolate Wubby",
				generalMidi: false,
				tags: ["fm", "fm4op", "dubstep", "bass"],
				settings: {
					type: "FM",
					eqFilter: [{ type: "high-pass", cutoffHz: 125, linearGain: 0.7071 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [{ type: "high-pass", cutoffHz: 125, linearGain: 0.7071 }],
					effects: ["chorus", "reverb"],
					panDelay: 10,
					chorus: 14,
					reverb: 6,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "1←2←3←4",
					feedbackType: "1⟲",
					feedbackAmplitude: 6,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 13, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "0.5×", amplitude: 13, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 4, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [{ target: "operatorAmplitude", envelope: "twang -1", index: 3 }],
				},
			},
			{
				name: "Chocolate Harsh",
				generalMidi: false,
				tags: ["fm", "fm4op", "distortion"],
				settings: {
					type: "FM",
					eqFilter: [{ type: "high-pass", cutoffHz: 125, linearGain: 0.7071 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [{ type: "high-pass", cutoffHz: 125, linearGain: 0.7071 }],
					effects: ["distortion", "bitcrusher"],
					distortion: 43,
					aliases: false,
					bitcrusherOctave: 3.5,
					bitcrusherQuantization: 0,
					panDelay: 10,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "1←2←(3 4)",
					feedbackType: "1⟲",
					feedbackAmplitude: 5,
					operators: [
						{ frequency: "3×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 4, waveform: "pulse width", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 8, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{ target: "operatorAmplitude", envelope: "twang -1", index: 3 },
						{
							target: "operatorAmplitude",
							envelope: "punch",
							index: 1,
						},
						{ target: "operatorAmplitude", envelope: "twang 1", index: 2 },
					],
				},
			},
			{
				name: "Chocolate Hyper",
				generalMidi: false,
				tags: ["chip", "customchip", "novelty"],
				settings: {
					type: "custom chip",
					eqFilter: [
						{ type: "peak", cutoffHz: 420.45, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 1414.21, linearGain: 0.0884 },
						{ type: "high-pass", cutoffHz: 148.65, linearGain: 0.7071 },
						{ type: "low-pass", cutoffHz: 16000, linearGain: 0.25 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 50,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "peak", cutoffHz: 420.45, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 1414.21, linearGain: 0.0884 },
						{ type: "high-pass", cutoffHz: 148.65, linearGain: 0.7071 },
						{ type: "low-pass", cutoffHz: 16000, linearGain: 0.25 },
					],
					effects: [],
					panDelay: 10,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					wave: "square",
					unison: "custom",
					unisonVoices: 1,
					unisonSpread: 60,
					unisonOffset: 0,
					unisonExpression: 1,
					unisonSign: 1,
					customChipWave: {
						"0": -23,
						"1": -22,
						"2": -19,
						"3": -15,
						"4": -7,
						"5": -4,
						"6": -1,
						"7": 2,
						"8": 7,
						"9": 12,
						"10": 16,
						"11": 19,
						"12": 19,
						"13": 19,
						"14": 19,
						"15": 16,
						"16": 15,
						"17": 7,
						"18": 0,
						"19": -4,
						"20": -6,
						"21": -7,
						"22": -4,
						"23": 3,
						"24": 9,
						"25": 11,
						"26": 13,
						"27": 14,
						"28": 15,
						"29": 16,
						"30": 17,
						"31": 17,
						"32": 17,
						"33": 16,
						"34": 15,
						"35": 12,
						"36": 10,
						"37": 8,
						"38": 5,
						"39": 3,
						"40": 2,
						"41": 0,
						"42": 0,
						"43": -1,
						"44": -1,
						"45": -2,
						"46": -2,
						"47": -2,
						"48": -2,
						"49": -2,
						"50": -2,
						"51": -2,
						"52": -3,
						"53": -8,
						"54": -11,
						"55": -13,
						"56": -14,
						"57": -16,
						"58": -16,
						"59": -18,
						"60": -19,
						"61": -19,
						"62": -19,
						"63": -20,
					},
					customChipWaveIntegral: {
						"0": 0,
						"1": 0,
						"2": 0,
						"3": 0,
						"4": 0,
						"5": 0,
						"6": 0,
						"7": 0,
						"8": 0,
						"9": 0,
						"10": 0,
						"11": 0,
						"12": 0,
						"13": 0,
						"14": 0,
						"15": 0,
						"16": 0,
						"17": 0,
						"18": 0,
						"19": 0,
						"20": 0,
						"21": 0,
						"22": 0,
						"23": 0,
						"24": 0,
						"25": 0,
						"26": 0,
						"27": 0,
						"28": 0,
						"29": 0,
						"30": 0,
						"31": 0,
						"32": 0,
						"33": 0,
						"34": 0,
						"35": 0,
						"36": 0,
						"37": 0,
						"38": 0,
						"39": 0,
						"40": 0,
						"41": 0,
						"42": 0,
						"43": 0,
						"44": 0,
						"45": 0,
						"46": 0,
						"47": 0,
						"48": 0,
						"49": 0,
						"50": 0,
						"51": 0,
						"52": 0,
						"53": 0,
						"54": 0,
						"55": 0,
						"56": 0,
						"57": 0,
						"58": 0,
						"59": 0,
						"60": 0,
						"61": 0,
						"62": 0,
						"63": 0,
						"64": 0,
					},
					envelopes: [{ target: "unison", envelope: "tremolo0" }],
				},
			},
			{
				name: "Chocolate wave",
				generalMidi: false,
				tags: ["chip", "customchip", "novelty"],
				settings: {
					type: "custom chip",
					eqFilter: [
						{ type: "high-pass", cutoffHz: 353.55, linearGain: 0.25 },
						{
							type: "peak",
							cutoffHz: 16000,
							linearGain: 2,
						},
						{ type: "peak", cutoffHz: 1414.21, linearGain: 0.0884 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 50,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "high-pass", cutoffHz: 353.55, linearGain: 0.25 },
						{
							type: "peak",
							cutoffHz: 16000,
							linearGain: 2,
						},
						{ type: "peak", cutoffHz: 1414.21, linearGain: 0.0884 },
					],
					effects: ["reverb"],
					panDelay: 10,
					reverb: 52,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					wave: "square",
					unison: "custom",
					unisonVoices: 1,
					unisonSpread: 60,
					unisonOffset: 0,
					unisonExpression: 1,
					unisonSign: 1,
					customChipWave: {
						"0": -23,
						"1": -22,
						"2": -19,
						"3": -15,
						"4": -7,
						"5": -4,
						"6": -1,
						"7": 2,
						"8": 7,
						"9": 12,
						"10": 16,
						"11": 19,
						"12": 19,
						"13": 19,
						"14": 19,
						"15": 16,
						"16": 15,
						"17": 7,
						"18": 0,
						"19": -4,
						"20": -6,
						"21": -7,
						"22": -4,
						"23": 3,
						"24": 9,
						"25": 11,
						"26": 13,
						"27": 14,
						"28": 15,
						"29": 16,
						"30": 17,
						"31": 17,
						"32": 17,
						"33": 16,
						"34": 15,
						"35": 12,
						"36": 10,
						"37": 8,
						"38": 5,
						"39": 3,
						"40": 2,
						"41": 0,
						"42": 0,
						"43": -1,
						"44": -1,
						"45": -2,
						"46": -2,
						"47": -2,
						"48": -2,
						"49": -2,
						"50": -2,
						"51": -2,
						"52": -3,
						"53": -8,
						"54": -11,
						"55": -13,
						"56": -14,
						"57": -16,
						"58": -16,
						"59": -18,
						"60": -19,
						"61": -19,
						"62": -19,
						"63": -20,
					},
					customChipWaveIntegral: {
						"0": 0,
						"1": 0,
						"2": 0,
						"3": 0,
						"4": 0,
						"5": 0,
						"6": 0,
						"7": 0,
						"8": 0,
						"9": 0,
						"10": 0,
						"11": 0,
						"12": 0,
						"13": 0,
						"14": 0,
						"15": 0,
						"16": 0,
						"17": 0,
						"18": 0,
						"19": 0,
						"20": 0,
						"21": 0,
						"22": 0,
						"23": 0,
						"24": 0,
						"25": 0,
						"26": 0,
						"27": 0,
						"28": 0,
						"29": 0,
						"30": 0,
						"31": 0,
						"32": 0,
						"33": 0,
						"34": 0,
						"35": 0,
						"36": 0,
						"37": 0,
						"38": 0,
						"39": 0,
						"40": 0,
						"41": 0,
						"42": 0,
						"43": 0,
						"44": 0,
						"45": 0,
						"46": 0,
						"47": 0,
						"48": 0,
						"49": 0,
						"50": 0,
						"51": 0,
						"52": 0,
						"53": 0,
						"54": 0,
						"55": 0,
						"56": 0,
						"57": 0,
						"58": 0,
						"59": 0,
						"60": 0,
						"61": 0,
						"62": 0,
						"63": 0,
						"64": 0,
					},
					envelopes: [{ target: "unison", envelope: "tremolo0" }],
				},
			},
			{
				name: "Chocolate Roar",
				generalMidi: false,
				tags: ["supersaw", "distortion"],
				settings: {
					type: "supersaw",
					eqFilter: [
						{ type: "peak", cutoffHz: 4000, linearGain: 4 },
						{ type: "peak", cutoffHz: 840.9, linearGain: 11.3137 },
						{ type: "peak", cutoffHz: 210.22, linearGain: 11.3137 },
						{ type: "peak", cutoffHz: 2000, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 420.45, linearGain: 0.0884 },
						{ type: "low-pass", cutoffHz: 16000, linearGain: 0.3536 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "peak", cutoffHz: 4000, linearGain: 4 },
						{ type: "peak", cutoffHz: 840.9, linearGain: 11.3137 },
						{ type: "peak", cutoffHz: 210.22, linearGain: 11.3137 },
						{ type: "peak", cutoffHz: 2000, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 420.45, linearGain: 0.0884 },
						{ type: "low-pass", cutoffHz: 16000, linearGain: 0.3536 },
					],
					eqSubFilters1: [
						{ type: "peak", cutoffHz: 840.9, linearGain: 11.3137 },
						{ type: "peak", cutoffHz: 4756.83, linearGain: 4 },
						{ type: "peak", cutoffHz: 148.65, linearGain: 11.3137 },
						{ type: "peak", cutoffHz: 420.45, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 2000, linearGain: 0.0884 },
						{ type: "low-pass", cutoffHz: 16000, linearGain: 0.3536 },
					],
					eqSubFilters2: [
						{ type: "peak", cutoffHz: 4756.83, linearGain: 2.8284 },
						{ type: "peak", cutoffHz: 176.78, linearGain: 11.3137 },
						{ type: "peak", cutoffHz: 840.9, linearGain: 11.3137 },
						{ type: "peak", cutoffHz: 594.6, linearGain: 0.125 },
						{ type: "peak", cutoffHz: 1681.79, linearGain: 0.0884 },
						{ type: "low-pass", cutoffHz: 16000, linearGain: 0.3536 },
					],
					eqSubFilters3: [
						{ type: "peak", cutoffHz: 3363.59, linearGain: 4 },
						{ type: "peak", cutoffHz: 1414.21, linearGain: 8 },
						{ type: "peak", cutoffHz: 297.3, linearGain: 11.3137 },
						{ type: "peak", cutoffHz: 840.9, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 176.78, linearGain: 0.0884 },
						{ type: "low-pass", cutoffHz: 16000, linearGain: 0.3536 },
					],
					eqSubFilters4: [
						{ type: "peak", cutoffHz: 176.78, linearGain: 11.3137 },
						{ type: "peak", cutoffHz: 4000, linearGain: 11.3137 },
						{ type: "peak", cutoffHz: 707.11, linearGain: 11.3137 },
						{ type: "peak", cutoffHz: 2000, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 353.55, linearGain: 0.0884 },
						{ type: "low-pass", cutoffHz: 16000, linearGain: 0.3536 },
					],
					effects: ["pitch shift", "note filter", "distortion", "bitcrusher", "chorus"],
					pitchShiftSemitones: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 4000, linearGain: 11.3137 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 4000, linearGain: 11.3137 }],
					distortion: 14,
					aliases: false,
					bitcrusherOctave: 4.5,
					bitcrusherQuantization: 100,
					panDelay: 10,
					chorus: 14,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					pulseWidth: 50,
					decimalOffset: 0,
					dynamism: 100,
					spread: 25,
					shape: 33,
					envelopes: [{ target: "noteFilterFreq", envelope: "note size", index: 0 }],
				},
			},
			{
				name: "Chocolate Kick",
				generalMidi: false,
				tags: ["fm", "fm4op", "kick", "featured"],
				settings: {
					type: "FM",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 16000, linearGain: 0.3536 },
						{ type: "peak", cutoffHz: 1681.79, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 500, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 148.65, linearGain: 1.4142 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 16000, linearGain: 0.3536 },
						{ type: "peak", cutoffHz: 1681.79, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 500, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 148.65, linearGain: 1.4142 },
					],
					effects: ["note filter", "distortion"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 11313.71, linearGain: 1 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 11313.71, linearGain: 1 }],
					distortion: 29,
					aliases: false,
					panDelay: 10,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "1←(2 3 4)",
					feedbackType: "1⟲",
					feedbackAmplitude: 8,
					operators: [
						{ frequency: "20×", amplitude: 15, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{ target: "operatorFrequency", envelope: "decay -1", index: 0 },
						{ target: "noteVolume", envelope: "twang 2" },
						{ target: "feedbackAmplitude", envelope: "flare 1" },
						{ target: "noteFilterFreq", envelope: "twang 2", index: 0 },
						{ target: "operatorFrequency", envelope: "decay 2", index: 0 },
					],
				},
			},
			{
				name: "Chocolate Slice (LS)",
				generalMidi: false,
				tags: ["chip", "chipwave", "lead"],
				settings: {
					type: "chip",
					eqFilter: [
						{ type: "peak", cutoffHz: 6727.17, linearGain: 0.0884 },
						{
							type: "peak",
							cutoffHz: 420.45,
							linearGain: 0.0884,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "peak", cutoffHz: 6727.17, linearGain: 0.0884 },
						{
							type: "peak",
							cutoffHz: 420.45,
							linearGain: 0.0884,
						},
					],
					effects: [
						"pitch shift",
						"detune",
						"vibrato",
						"distortion",
						"bitcrusher",
						"chorus",
						"reverb",
					],
					pitchShiftSemitones: 21,
					detuneCents: 72,
					vibrato: "light",
					vibratoDepth: 0.15,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 0,
					distortion: 29,
					aliases: true,
					bitcrusherOctave: 4.5,
					bitcrusherQuantization: 14,
					panDelay: 10,
					chorus: 14,
					reverb: 10,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					wave: "paandorasbeta sunsoft bass",
					unison: "none",
					isUsingAdvancedLoopControls: true,
					chipWaveLoopStart: 3294,
					chipWaveLoopEnd: 4585,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [],
				},
			},
			{
				name: "Evil Drawbar",
				generalMidi: false,
				tags: ["fm", "fm6op", "bellows"],
				settings: {
					type: "FM6op",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [],
					effects: ["transition type", "bitcrusher", "reverb"],
					transition: "normal",
					clicklessTransition: false,
					bitcrusherOctave: 5,
					bitcrusherQuantization: 14,
					panDelay: 10,
					reverb: 35,
					fadeInSeconds: 0,
					fadeOutTicks: 6,
					algorithm: "Custom",
					feedbackType: "1⟲ 2⟲",
					feedbackAmplitude: 2,
					customAlgorithm: { mods: [[4], [6], [], [5], [6], []], carrierCount: 3 },
					operators: [
						{ frequency: "2×", amplitude: 2, waveform: "sine", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 7, waveform: "sine", pulseWidth: 5 },
						{ frequency: "8×", amplitude: 9, waveform: "sine", pulseWidth: 5 },
						{ frequency: "4×", amplitude: 7, waveform: "sine", pulseWidth: 5 },
						{ frequency: "8×", amplitude: 11, waveform: "sine", pulseWidth: 5 },
						{ frequency: "~1×", amplitude: 7, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [],
				},
			},
			{
				name: "Bullet Punch Bass",
				generalMidi: false,
				tags: ["fm", "fm4op", "bass"],
				settings: {
					type: "FM",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 8000, linearGain: 1.4142 },
						{
							type: "peak",
							cutoffHz: 2828.43,
							linearGain: 0.7071,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 8000, linearGain: 1.4142 },
						{
							type: "peak",
							cutoffHz: 2828.43,
							linearGain: 0.7071,
						},
					],
					effects: ["vibrato", "note filter", "bitcrusher"],
					vibrato: "delayed",
					vibratoDepth: 0.3,
					vibratoDelay: 18.5,
					vibratoSpeed: 10,
					vibratoType: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 840.9, linearGain: 0.3536 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 840.9, linearGain: 0.3536 }],
					bitcrusherOctave: 6.5,
					bitcrusherQuantization: 71,
					panDelay: 10,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "1 2 3←4",
					feedbackType: "ALL",
					feedbackAmplitude: 2,
					operators: [
						{ frequency: "3.5×", amplitude: 12, waveform: "trapezoid", pulseWidth: 5 },
						{ frequency: "0.25×", amplitude: 13, waveform: "sine", pulseWidth: 5 },
						{ frequency: "0.12×", amplitude: 9, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 8, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{ target: "noteFilterAllFreqs", envelope: "twang 2" },
						{
							target: "operatorAmplitude",
							envelope: "wibble 3",
							index: 3,
						},
					],
				},
			},
			{
				name: "Strawberry Soup",
				generalMidi: false,
				tags: ["fm", "fm6op", "distortion", "bass"],
				settings: {
					type: "FM6op",
					eqFilter: [
						{ type: "high-pass", cutoffHz: 62.5, linearGain: 2.8284 },
						{
							type: "peak",
							cutoffHz: 2378.41,
							linearGain: 0.7071,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "high-pass", cutoffHz: 62.5, linearGain: 2.8284 },
						{
							type: "peak",
							cutoffHz: 2378.41,
							linearGain: 0.7071,
						},
					],
					effects: ["distortion", "echo", "reverb"],
					distortion: 100,
					aliases: false,
					panDelay: 10,
					echoSustain: 57,
					echoDelayBeats: 1,
					reverb: 10,
					fadeInSeconds: 0.0263,
					fadeOutTicks: -3,
					algorithm: "1 2 3←5 4←6",
					feedbackType: "1→5",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "0.12×", amplitude: 12, waveform: "sine", pulseWidth: 5 },
						{
							frequency: "0.12×",
							amplitude: 14,
							waveform: "pulse width",
							pulseWidth: 6,
						},
						{ frequency: "1×", amplitude: 2, waveform: "sine", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 15, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "0.75×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{
							frequency: "0.75×",
							amplitude: 2,
							waveform: "pulse width",
							pulseWidth: 4,
						},
					],
					envelopes: [{ target: "operatorAmplitude", envelope: "linear 1", index: 5 }],
				},
			},
			{
				name: "Good Drawbar",
				generalMidi: false,
				tags: ["fm", "fm6op", "bellows"],
				settings: {
					type: "FM6op",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 1000, linearGain: 0.3536 },
						{
							type: "high-pass",
							cutoffHz: 74.33,
							linearGain: 0.25,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 1000, linearGain: 0.3536 },
						{
							type: "high-pass",
							cutoffHz: 74.33,
							linearGain: 0.25,
						},
					],
					effects: ["detune", "note filter"],
					detuneCents: 0,
					noteFilterType: true,
					noteSimpleCut: 7,
					noteSimplePeak: 1,
					noteFilter: [],
					panDelay: 10,
					fadeInSeconds: 0,
					fadeOutTicks: 12,
					algorithm: "1 2←5 (3 4)←6",
					feedbackType: "2→1→6→5→4→3→2",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "~2×", amplitude: 11, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "4×", amplitude: 12, waveform: "sine", pulseWidth: 5 },
						{ frequency: "3×", amplitude: 3, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "4×", amplitude: 3, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{ target: "noteFilterAllFreqs", envelope: "decay 3" },
						{
							target: "operatorAmplitude",
							envelope: "tremolo3",
							index: 5,
						},
					],
				},
			},
			{
				name: "Yow Pad",
				generalMidi: false,
				tags: ["fm", "fm4op", "bass"],
				settings: {
					type: "FM",
					eqFilter: [],
					eqFilterType: true,
					eqSimpleCut: 8,
					eqSimplePeak: 1,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					effects: ["vibrato", "note filter", "reverb"],
					vibrato: "delayed",
					vibratoDepth: 0.3,
					vibratoDelay: 18.5,
					vibratoSpeed: 10,
					vibratoType: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 5656.85, linearGain: 4 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 5656.85, linearGain: 4 }],
					panDelay: 10,
					reverb: 3,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "(1 2)←3←4",
					feedbackType: "4⟲",
					feedbackAmplitude: 7,
					operators: [
						{
							frequency: "0.12×",
							amplitude: 12,
							waveform: "pulse width",
							pulseWidth: 8,
						},
						{ frequency: "3.5×", amplitude: 0, waveform: "pulse width", pulseWidth: 2 },
						{ frequency: "1×", amplitude: 1, waveform: "sine", pulseWidth: 5 },
						{ frequency: "3×", amplitude: 2, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{ target: "noteFilterAllFreqs", envelope: "decay 3" },
						{
							target: "operatorAmplitude",
							envelope: "twang 2",
							index: 2,
						},
					],
				},
			},
			{
				name: "Coconut Pluck68",
				generalMidi: false,
				tags: ["pickedstring", "picked"],
				settings: {
					type: "Picked String",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 9,
					discreteEnvelope: false,
					eqSubFilters0: [],
					effects: ["note filter", "distortion", "chorus", "echo"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.5 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.5 }],
					distortion: 71,
					aliases: false,
					panDelay: 10,
					chorus: 29,
					echoSustain: 43,
					echoDelayBeats: 0.75,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					harmonics: [
						100, 0, 100, 0, 100, 0, 100, 0, 100, 0, 100, 0, 100, 0, 100, 0, 100, 0, 100,
						0, 100, 0, 100, 0, 100, 0, 100, 0,
					],
					unison: "none",
					stringSustain: 57,
					envelopes: [
						{ target: "stringSustain", envelope: "tremolo3" },
						{
							target: "noteFilterFreq",
							envelope: "twang -1",
							index: 0,
						},
					],
				},
			},
			{
				name: "Coconut Saw68",
				midiProgram: 96,
				tags: ["supersaw", "bass"],
				settings: {
					type: "supersaw",
					eqFilter: [{ type: "high-pass", cutoffHz: 148.65, linearGain: 0.7071 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 1,
					discreteEnvelope: false,
					eqSubFilters0: [{ type: "high-pass", cutoffHz: 148.65, linearGain: 0.7071 }],
					effects: ["transition type", "note filter", "chorus", "reverb"],
					transition: "interrupt",
					clicklessTransition: false,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "peak", cutoffHz: 1189.21, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 1414.21, linearGain: 11.3137 },
						{ type: "peak", cutoffHz: 2378.41, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 2828.43, linearGain: 11.3137 },
						{ type: "peak", cutoffHz: 4756.83, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 5656.85, linearGain: 11.3137 },
						{ type: "peak", cutoffHz: 9513.66, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 11313.71, linearGain: 11.3137 },
					],
					noteSubFilters0: [
						{ type: "peak", cutoffHz: 1189.21, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 1414.21, linearGain: 11.3137 },
						{ type: "peak", cutoffHz: 2378.41, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 2828.43, linearGain: 11.3137 },
						{ type: "peak", cutoffHz: 4756.83, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 5656.85, linearGain: 11.3137 },
						{ type: "peak", cutoffHz: 9513.66, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 11313.71, linearGain: 11.3137 },
					],
					panDelay: 10,
					chorus: 57,
					reverb: 29,
					fadeInSeconds: 0,
					fadeOutTicks: 24,
					pulseWidth: 50,
					decimalOffset: 0,
					dynamism: 100,
					spread: 42,
					shape: 0,
					envelopes: [{ target: "noteFilterAllFreqs", envelope: "tremolo3" }],
				},
			},
			{
				name: "Coconut Harp68",
				generalMidi: false,
				tags: ["chip", "chipwave", "string"],
				settings: {
					type: "chip",
					eqFilter: [
						{ type: "high-pass", cutoffHz: 176.78, linearGain: 0.3536 },
						{ type: "peak", cutoffHz: 4000, linearGain: 0.3536 },
						{ type: "peak", cutoffHz: 707.11, linearGain: 0.3536 },
						{ type: "peak", cutoffHz: 2000, linearGain: 1.4142 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "high-pass", cutoffHz: 176.78, linearGain: 0.3536 },
						{ type: "peak", cutoffHz: 4000, linearGain: 0.3536 },
						{ type: "peak", cutoffHz: 707.11, linearGain: 0.3536 },
						{ type: "peak", cutoffHz: 2000, linearGain: 1.4142 },
					],
					effects: ["detune", "vibrato", "note filter", "chorus", "reverb"],
					detuneCents: 200,
					vibrato: "custom",
					vibratoDepth: 0.12,
					vibratoDelay: 1,
					vibratoSpeed: 1,
					vibratoType: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 16000, linearGain: 0.5 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 16000, linearGain: 0.5 }],
					panDelay: 10,
					chorus: 43,
					reverb: 61,
					fadeInSeconds: 0.0263,
					fadeOutTicks: 96,
					wave: "rounded",
					unison: "custom",
					unisonVoices: 2,
					unisonSpread: 6,
					unisonOffset: 16,
					unisonExpression: 1,
					unisonSign: -1,
					isUsingAdvancedLoopControls: false,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 64,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [
						{ target: "noteFilterFreq", envelope: "flare 1", index: 0 },
						{
							target: "noteVolume",
							envelope: "twang 2",
						},
					],
				},
			},
			{
				name: "Coconut Cowbell68",
				generalMidi: false,
				tags: ["harmonics", "drum"],
				settings: {
					type: "harmonics",
					eqFilter: [
						{ type: "peak", cutoffHz: 250, linearGain: 11.3137 },
						{ type: "peak", cutoffHz: 2378.41, linearGain: 5.6569 },
						{ type: "low-pass", cutoffHz: 13454.34, linearGain: 0.7071 },
						{ type: "high-pass", cutoffHz: 125, linearGain: 0.7071 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "peak", cutoffHz: 250, linearGain: 11.3137 },
						{ type: "peak", cutoffHz: 2378.41, linearGain: 5.6569 },
						{ type: "low-pass", cutoffHz: 13454.34, linearGain: 0.7071 },
						{ type: "high-pass", cutoffHz: 125, linearGain: 0.7071 },
					],
					effects: ["detune", "distortion"],
					detuneCents: -32,
					distortion: 29,
					aliases: false,
					panDelay: 10,
					fadeInSeconds: 0,
					fadeOutTicks: 48,
					harmonics: [
						57, 71, 86, 43, 0, 100, 0, 29, 0, 0, 0, 57, 0, 0, 0, 57, 0, 43, 0, 0, 0, 57,
						0, 43, 0, 0, 0, 0,
					],
					unison: "stationary",
					envelopes: [{ target: "noteVolume", envelope: "twang 1" }],
				},
			},
			{
				name: "Coconut Bass68",
				midiProgram: 34,
				tags: ["fm", "fm4op", "bass"],
				settings: {
					type: "FM",
					eqFilter: [{ type: "peak", cutoffHz: 297.3, linearGain: 0.3536 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [{ type: "peak", cutoffHz: 297.3, linearGain: 0.3536 }],
					effects: ["bitcrusher", "chorus"],
					bitcrusherOctave: 5.5,
					bitcrusherQuantization: 0,
					panDelay: 10,
					chorus: 43,
					fadeInSeconds: 0,
					fadeOutTicks: -3,
					algorithm: "1←(2 3 4)",
					feedbackType: "1⟲",
					feedbackAmplitude: 5,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 5, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{ target: "feedbackAmplitude", envelope: "twang 1" },
						{
							target: "operatorAmplitude",
							envelope: "twang 2",
							index: 1,
						},
					],
				},
			},
			{
				name: "Coconut Kick Body68",
				generalMidi: false,
				tags: ["fm", "fm4op", "kick"],
				settings: {
					type: "FM",
					eqFilter: [
						{ type: "peak", cutoffHz: 125, linearGain: 2 },
						{
							type: "peak",
							cutoffHz: 420.45,
							linearGain: 0.1768,
						},
						{ type: "peak", cutoffHz: 1000, linearGain: 0.1768 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "peak", cutoffHz: 125, linearGain: 2 },
						{
							type: "peak",
							cutoffHz: 420.45,
							linearGain: 0.1768,
						},
						{ type: "peak", cutoffHz: 1000, linearGain: 0.1768 },
					],
					effects: ["pitch shift", "distortion", "bitcrusher"],
					pitchShiftSemitones: 7,
					distortion: 14,
					aliases: false,
					bitcrusherOctave: 5.5,
					bitcrusherQuantization: 14,
					panDelay: 10,
					fadeInSeconds: 0,
					fadeOutTicks: -12,
					algorithm: "1←(2 3 4)",
					feedbackType: "1⟲",
					feedbackAmplitude: 2,
					operators: [
						{ frequency: "8×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{ target: "operatorFrequency", envelope: "twang 1", index: 0 },
						{
							target: "noteVolume",
							envelope: "twang 2",
						},
						{ target: "pitchShift", envelope: "twang 1" },
					],
				},
			},
			{
				name: "Coconut Kick Hit68",
				generalMidi: false,
				tags: ["fm", "fm4op", "drums", "kick"],
				settings: {
					type: "FM",
					eqFilter: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.25 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.25 }],
					effects: ["pitch shift", "distortion"],
					pitchShiftSemitones: 24,
					distortion: 29,
					aliases: false,
					panDelay: 10,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "1←(2 3 4)",
					feedbackType: "ALL",
					feedbackAmplitude: 15,
					operators: [
						{ frequency: "8×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "9×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "9×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "8×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{ target: "operatorFrequency", envelope: "twang 1", index: 0 },
						{ target: "noteVolume", envelope: "punch" },
						{ target: "noteVolume", envelope: "twang -1" },
						{ target: "noteVolume", envelope: "twang -1" },
						{ target: "noteVolume", envelope: "twang -1" },
					],
				},
			},
			{
				name: "Coconut Snare Body68",
				generalMidi: false,
				tags: ["noise", "snare"],
				settings: {
					type: "noise",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 13454.34, linearGain: 0.5 },
						{ type: "high-pass", cutoffHz: 210.22, linearGain: 0.5 },
						{ type: "peak", cutoffHz: 1414.21, linearGain: 2.8284 },
						{ type: "peak", cutoffHz: 2828.43, linearGain: 2 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 13454.34, linearGain: 0.5 },
						{ type: "high-pass", cutoffHz: 210.22, linearGain: 0.5 },
						{ type: "peak", cutoffHz: 1414.21, linearGain: 2.8284 },
						{ type: "peak", cutoffHz: 2828.43, linearGain: 2 },
					],
					effects: ["detune", "chorus"],
					detuneCents: -20,
					panDelay: 10,
					chorus: 29,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					wave: "1-bit white",
					unison: "none",
					envelopes: [{ target: "noteVolume", envelope: "twang 1" }],
				},
			},
			{
				name: "Coconut Snare Clap68",
				generalMidi: false,
				tags: ["noise", "snare"],
				settings: {
					type: "noise",
					eqFilter: [
						{ type: "peak", cutoffHz: 3363.59, linearGain: 0.0884 },
						{
							type: "peak",
							cutoffHz: 594.6,
							linearGain: 0.0884,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "peak", cutoffHz: 3363.59, linearGain: 0.0884 },
						{
							type: "peak",
							cutoffHz: 594.6,
							linearGain: 0.0884,
						},
					],
					effects: ["chorus"],
					panDelay: 10,
					chorus: 29,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					wave: "crackling",
					unison: "none",
					envelopes: [{ target: "noteVolume", envelope: "twang 1" }],
				},
			},
			{
				name: "Coconut Hi-Hat68",
				generalMidi: false,
				tags: ["spectrum", "drum"],
				settings: {
					type: "spectrum",
					eqFilter: [
						{ type: "peak", cutoffHz: 8000, linearGain: 1.4142 },
						{ type: "peak", cutoffHz: 594.6, linearGain: 0.3536 },
						{ type: "peak", cutoffHz: 1681.79, linearGain: 0.5 },
						{ type: "peak", cutoffHz: 4000, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 125, linearGain: 0.3536 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "peak", cutoffHz: 8000, linearGain: 1.4142 },
						{ type: "peak", cutoffHz: 594.6, linearGain: 0.3536 },
						{ type: "peak", cutoffHz: 1681.79, linearGain: 0.5 },
						{ type: "peak", cutoffHz: 4000, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 125, linearGain: 0.3536 },
					],
					effects: ["chord type", "note filter", "chorus", "reverb"],
					chord: "strum",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 16000, linearGain: 0.7071 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 16000, linearGain: 0.7071 }],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 4000, linearGain: 0.5 }],
					panDelay: 10,
					chorus: 14,
					reverb: 10,
					fadeInSeconds: 0,
					fadeOutTicks: 24,
					spectrum: [
						14, 29, 29, 14, 29, 29, 29, 14, 29, 29, 43, 29, 29, 43, 43, 43, 43, 57, 43,
						71, 57, 71, 71, 86, 100, 100, 71, 43, 71, 71,
					],
					unison: "none",
					envelopes: [{ target: "noteFilterFreq", envelope: "twang 3", index: 0 }],
				},
			},
		]),
	},
	{
		name: "Gelli's Vanilla Challenge",
		presets: toNameMap([
			{
				name: "ufo pad",
				generalMidi: false,
				tags: ["fm", "fm4op", "pad"],
				settings: {
					type: "FM",
					eqFilter: [],
					effects: ["note filter", "chorus"],
					noteFilter: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.3536 }],
					chorus: 33,
					fadeInSeconds: 0.1575,
					fadeOutTicks: 96,
					algorithm: "1←(2 3 4)",
					feedbackType: "1⟲ 2⟲ 3⟲ 4⟲",
					feedbackAmplitude: 5,
					operators: [
						{ frequency: "1×", amplitude: 15 },
						{ frequency: "~1×", amplitude: 3 },
						{
							frequency: "8×",
							amplitude: 1,
						},
						{ frequency: "1×", amplitude: 4 },
					],
					envelopes: [],
				},
			},
			{
				name: "pulse string",
				generalMidi: false,
				tags: ["fm", "fm4op", "string"],
				settings: {
					type: "FM",
					eqFilter: [
						{ type: "peak", cutoffHz: 9513.66, linearGain: 1 },
						{
							type: "peak",
							cutoffHz: 594.6,
							linearGain: 1.4142,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "peak", cutoffHz: 9513.66, linearGain: 1 },
						{
							type: "peak",
							cutoffHz: 594.6,
							linearGain: 1.4142,
						},
					],
					effects: ["chord type", "note filter", "echo"],
					chord: "strum",
					fastTwoNoteArp: true,
					arpeggioSpeed: 12,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 16000, linearGain: 0.7071 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 16000, linearGain: 0.7071 }],
					panDelay: 0,
					echoSustain: 29,
					echoDelayBeats: 0.667,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "1←(2 3)←4",
					feedbackType: "1⟲",
					feedbackAmplitude: 10,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "6×", amplitude: 4, waveform: "sine", pulseWidth: 5 },
						{ frequency: "20×", amplitude: 3, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 10, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{ target: "noteFilterAllFreqs", envelope: "twang 1" },
						{ target: "operatorAmplitude", envelope: "twang 1", index: 2 },
						{ target: "operatorAmplitude", envelope: "tremolo1", index: 3 },
						{ target: "noteVolume", envelope: "flare 1" },
					],
				},
			},
			{
				name: "guitar bass",
				generalMidi: false,
				tags: ["fm", "fm4op", "distortion", "guitar", "bass"],
				settings: {
					type: "FM",
					eqFilter: [{ type: "low-pass", cutoffHz: 2000, linearGain: 0.5 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 2000, linearGain: 0.5 }],
					effects: [],
					fadeInSeconds: 0,
					fadeOutTicks: -3,
					algorithm: "1←(2 3←4)",
					feedbackType: "1⟲ 2⟲ 3⟲ 4⟲",
					feedbackAmplitude: 7,
					operators: [
						{ frequency: "3×", amplitude: 12, waveform: "sine", pulseWidth: 5 },
						{ frequency: "~1×", amplitude: 7, waveform: "sine", pulseWidth: 5 },
						{ frequency: "4×", amplitude: 6, waveform: "sine", pulseWidth: 5 },
						{ frequency: "3×", amplitude: 7, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [{ target: "feedbackAmplitude", envelope: "twang 2" }],
				},
			},
			{
				name: "frog kick",
				generalMidi: false,
				tags: ["fm", "fm4op", "kick"],
				settings: {
					type: "FM",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 13454.34, linearGain: 0.3536 },
						{
							type: "low-pass",
							cutoffHz: 420.45,
							linearGain: 2.8284,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 13454.34, linearGain: 0.3536 },
						{
							type: "low-pass",
							cutoffHz: 420.45,
							linearGain: 2.8284,
						},
					],
					effects: ["bitcrusher"],
					bitcrusherOctave: 0,
					bitcrusherQuantization: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -6,
					algorithm: "1←(2 3 4)",
					feedbackType: "1⟲",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "8×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{ target: "operatorFrequency", envelope: "twang 1", index: 0 },
						{
							target: "noteVolume",
							envelope: "twang 2",
						},
					],
				},
			},
			{
				name: "wigglecore drtumset - Gelli",
				generalMidi: false,
				isNoise: true,
				tags: ["drumset", "novelty", "drum"],
				settings: {
					type: "drumset",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 9513.66, linearGain: 1 },
						{
							type: "peak",
							cutoffHz: 250,
							linearGain: 0.7071,
						},
						{ type: "peak", cutoffHz: 1681.79, linearGain: 2.8284 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 9513.66, linearGain: 1 },
						{
							type: "peak",
							cutoffHz: 250,
							linearGain: 0.7071,
						},
						{ type: "peak", cutoffHz: 1681.79, linearGain: 2.8284 },
					],
					effects: ["vibrato", "note filter", "distortion", "chorus"],
					vibrato: "heavy",
					vibratoDepth: 0.45,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 4756.83, linearGain: 0.7071 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 4756.83, linearGain: 0.7071 }],
					distortion: 100,
					aliases: false,
					panDelay: 0,
					chorus: 29,
					drums: [
						{
							filterEnvelope: "twang 1",
							spectrum: [
								57, 71, 71, 86, 86, 86, 71, 71, 71, 71, 57, 57, 57, 57, 43, 43, 43,
								43, 29, 29, 29, 29, 29, 29, 29, 29, 29, 29, 29, 29,
							],
						},
						{
							filterEnvelope: "twang 1",
							spectrum: [
								0, 0, 0, 100, 71, 71, 57, 86, 57, 57, 57, 71, 43, 43, 57, 43, 43,
								43, 43, 43, 43, 43, 43, 43, 43, 43, 43, 43, 43, 43,
							],
						},
						{
							filterEnvelope: "twang 1",
							spectrum: [
								0, 0, 0, 0, 100, 57, 43, 43, 29, 57, 43, 29, 71, 43, 43, 43, 43, 57,
								43, 43, 43, 43, 43, 43, 43, 43, 29, 43, 43, 43,
							],
						},
						{
							filterEnvelope: "twang 1",
							spectrum: [
								0, 0, 0, 0, 0, 71, 57, 43, 43, 43, 57, 57, 43, 29, 57, 43, 43, 43,
								29, 43, 57, 43, 43, 43, 43, 43, 43, 29, 43, 43,
							],
						},
						{
							filterEnvelope: "decay 2",
							spectrum: [
								0, 14, 29, 43, 86, 71, 29, 43, 43, 43, 43, 29, 71, 29, 71, 29, 43,
								43, 43, 43, 57, 43, 43, 57, 43, 43, 43, 57, 57, 57,
							],
						},
						{
							filterEnvelope: "decay 1",
							spectrum: [
								0, 0, 14, 14, 14, 14, 29, 29, 29, 43, 43, 43, 57, 57, 57, 71, 71,
								71, 71, 71, 71, 71, 71, 57, 57, 57, 57, 43, 43, 43,
							],
						},
						{
							filterEnvelope: "twang 3",
							spectrum: [
								43, 43, 43, 71, 29, 29, 43, 43, 43, 29, 43, 43, 43, 29, 29, 43, 43,
								29, 29, 29, 57, 14, 57, 43, 43, 57, 43, 43, 57, 57,
							],
						},
						{
							filterEnvelope: "decay 3",
							spectrum: [
								29, 43, 43, 43, 43, 29, 29, 43, 29, 29, 43, 29, 14, 29, 43, 29, 43,
								29, 57, 29, 43, 57, 43, 71, 43, 71, 57, 57, 71, 71,
							],
						},
						{
							filterEnvelope: "twang 3",
							spectrum: [
								43, 29, 29, 43, 29, 29, 29, 57, 29, 29, 29, 57, 43, 43, 29, 29, 57,
								43, 43, 43, 71, 43, 43, 71, 57, 71, 71, 71, 71, 71,
							],
						},
						{
							filterEnvelope: "decay 3",
							spectrum: [
								57, 57, 57, 43, 57, 57, 43, 43, 57, 43, 43, 43, 71, 57, 43, 57, 86,
								71, 57, 86, 71, 57, 86, 100, 71, 86, 86, 86, 86, 86,
							],
						},
						{
							filterEnvelope: "flare 1",
							spectrum: [
								0, 0, 14, 14, 14, 14, 29, 29, 29, 43, 43, 43, 57, 57, 71, 71, 86,
								86, 100, 100, 100, 100, 100, 100, 100, 100, 86, 57, 29, 0,
							],
						},
						{
							filterEnvelope: "decay 2",
							spectrum: [
								14, 14, 14, 14, 29, 14, 14, 29, 14, 43, 14, 43, 57, 86, 57, 57, 100,
								57, 43, 43, 57, 100, 57, 43, 29, 14, 0, 0, 0, 0,
							],
						},
					],
					envelopes: [
						{ target: "noteVolume", envelope: "decay 1" },
						{
							target: "noteFilterFreq",
							envelope: "punch",
							index: 0,
						},
					],
				},
			},
		]),
	},
	{
		name: "BeepBox T6 R3 Bonus Presets",
		presets: toNameMap([
			// set 1
			{
				name: "T6 Cactus",
				generalMidi: false,
				tags: ["fm", "fm4op", "novelty"],
				settings: {
					type: "FM",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 8000, linearGain: 0.1768 },
						{
							type: "peak",
							cutoffHz: 594.6,
							linearGain: 0.5,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 8000, linearGain: 0.1768 },
						{
							type: "peak",
							cutoffHz: 594.6,
							linearGain: 0.5,
						},
					],
					effects: [],
					fadeInSeconds: 0,
					fadeOutTicks: 6,
					algorithm: "(1 2 3)←4",
					feedbackType: "2⟲",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "7×", amplitude: 14, waveform: "sine", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 13, waveform: "ramp", pulseWidth: 5 },
						{ frequency: "~1×", amplitude: 11, waveform: "sine", pulseWidth: 5 },
						{ frequency: "4×", amplitude: 14, waveform: "trapezoid", pulseWidth: 5 },
					],
					envelopes: [],
				},
			},
			{
				name: "T6 Betheor",
				generalMidi: false,
				tags: ["fm", "fm4op", "novelty"],
				settings: {
					type: "FM",
					eqFilter: [{ type: "low-pass", cutoffHz: 11313.71, linearGain: 0.0884 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 11313.71, linearGain: 0.0884 }],
					effects: [],
					fadeInSeconds: 0,
					fadeOutTicks: 24,
					algorithm: "1←(2 3 4)",
					feedbackType: "3→4",
					feedbackAmplitude: 6,
					operators: [
						{ frequency: "3×", amplitude: 10, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 13, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 13, waveform: "pulse width", pulseWidth: 4 },
						{ frequency: "6×", amplitude: 1, waveform: "triangle", pulseWidth: 5 },
					],
					envelopes: [],
				},
			},
			// set 2
			{
				name: "T6 Gongoozler",
				generalMidi: false,
				tags: ["pickedstring", "picked"],
				settings: {
					type: "Picked String",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 16000, linearGain: 2.8284 },
						{
							type: "high-pass",
							cutoffHz: 74.33,
							linearGain: 2,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 16000, linearGain: 2.8284 },
						{
							type: "high-pass",
							cutoffHz: 74.33,
							linearGain: 2,
						},
					],
					effects: [],
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					harmonics: [
						100, 29, 14, 14, 14, 14, 29, 14, 14, 14, 29, 14, 14, 14, 0, 14, 14, 0, 14,
						14, 14, 0, 0, 0, 14, 14, 14, 0,
					],
					unison: "octave",
					stringSustain: 29,
					envelopes: [],
				},
			},
			{
				name: "T6 Twingly",
				generalMidi: false,
				tags: ["pickedstring", "picked"],
				settings: {
					type: "Picked String",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 4000, linearGain: 1 },
						{ type: "high-pass", cutoffHz: 353.55, linearGain: 0.3536 },
						{ type: "peak", cutoffHz: 1189.21, linearGain: 0.1768 },
						{ type: "peak", cutoffHz: 13454.34, linearGain: 0.3536 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 50,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 4000, linearGain: 1 },
						{ type: "high-pass", cutoffHz: 353.55, linearGain: 0.3536 },
						{ type: "peak", cutoffHz: 1189.21, linearGain: 0.1768 },
						{ type: "peak", cutoffHz: 13454.34, linearGain: 0.3536 },
					],
					effects: [],
					fadeInSeconds: 0,
					fadeOutTicks: -6,
					harmonics: [
						100, 86, 57, 57, 43, 43, 100, 14, 14, 71, 71, 57, 43, 57, 14, 29, 57, 14,
						43, 57, 0, 43, 29, 29, 0, 14, 29, 14,
					],
					unison: "honky tonk",
					stringSustain: 21,
					envelopes: [],
				},
			},
			{
				name: "T6 Whooshy Wiosh",
				generalMidi: false,
				isNoise: true,
				tags: ["spectrum", "ambience"],
				settings: {
					type: "spectrum",
					eqFilter: [],
					eqFilterType: true,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					effects: [],
					fadeInSeconds: 0.0263,
					fadeOutTicks: -3,
					spectrum: [
						100, 43, 14, 14, 71, 14, 29, 0, 71, 14, 71, 0, 57, 14, 29, 43, 29, 14, 14,
						43, 14, 0, 29, 29, 71, 0, 14, 29, 14, 14,
					],
					envelopes: [],
				},
			},
			// set 3
			{
				name: "T6 Dying Mouse",
				generalMidi: false,
				tags: ["pickedstring", "picked"],
				settings: {
					type: "Picked String",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [],
					effects: [],
					fadeInSeconds: 0,
					fadeOutTicks: 48,
					harmonics: [
						100, 43, 14, 43, 43, 29, 43, 29, 43, 29, 14, 14, 14, 14, 29, 0, 14, 0, 0, 0,
						14, 14, 14, 0, 14, 14, 14, 0,
					],
					unison: "none",
					stringSustain: 71,
					envelopes: [],
				},
			},
			{
				name: "T6 Eyeless Lizard",
				generalMidi: false,
				tags: ["supersaw", "distortion"],
				settings: {
					type: "supersaw",
					eqFilter: [
						{ type: "peak", cutoffHz: 1414.21, linearGain: 1.4142 },
						{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.125 },
						{ type: "high-pass", cutoffHz: 62.5, linearGain: 0.125 },
						{ type: "high-pass", cutoffHz: 105.11, linearGain: 11.3137 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "peak", cutoffHz: 1414.21, linearGain: 1.4142 },
						{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.125 },
						{ type: "high-pass", cutoffHz: 62.5, linearGain: 0.125 },
						{ type: "high-pass", cutoffHz: 105.11, linearGain: 11.3137 },
					],
					effects: [],
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					pulseWidth: 32,
					dynamism: 83,
					spread: 50,
					shape: 50,
					envelopes: [],
				},
			},
			{
				name: "T6 stylus",
				generalMidi: false,
				tags: ["fm", "fm4op", "novelty"],
				settings: {
					type: "FM",
					eqFilter: [
						{ type: "peak", cutoffHz: 2828.43, linearGain: 0.0884 },
						{
							type: "peak",
							cutoffHz: 250,
							linearGain: 0.0884,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "peak", cutoffHz: 2828.43, linearGain: 0.0884 },
						{
							type: "peak",
							cutoffHz: 250,
							linearGain: 0.0884,
						},
					],
					effects: [],
					fadeInSeconds: 0,
					fadeOutTicks: -3,
					algorithm: "1←2←3←4",
					feedbackType: "1⟲ 2⟲ 3⟲ 4⟲",
					feedbackAmplitude: 1,
					operators: [
						{ frequency: "1×", amplitude: 13, waveform: "trapezoid", pulseWidth: 5 },
						{ frequency: "8×", amplitude: 0, waveform: "pulse width", pulseWidth: 3 },
						{ frequency: "4×", amplitude: 9, waveform: "sine", pulseWidth: 5 },
						{ frequency: "~2×", amplitude: 11, waveform: "sawtooth", pulseWidth: 5 },
					],
					envelopes: [],
				},
			},
		]),
	},
	{
		name: "CoolTasDude's Presets",
		presets: toNameMap([
			// Jukebox 0.0.1
			{
				name: "electrodonk",
				generalMidi: false,
				tags: ["pwm", "cooltasdude", "novelty"],
				settings: {
					type: "PWM",
					volume: 0,
					eqFilter: [
						{ type: "low-pass", cutoffHz: 11313.71, linearGain: 0.5 },
						{
							type: "high-pass",
							cutoffHz: 210.22,
							linearGain: 2,
						},
						{ type: "peak", cutoffHz: 707.11, linearGain: 1.4142 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					preset: 1728,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 11313.71, linearGain: 0.5 },
						{
							type: "high-pass",
							cutoffHz: 210.22,
							linearGain: 2,
						},
						{ type: "peak", cutoffHz: 707.11, linearGain: 1.4142 },
					],
					effects: ["panning", "chord type", "vibrato", "note filter", "reverb"],
					chord: "strum",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					monoChordTone: 1,
					vibrato: "shaky",
					vibratoDepth: 0.1,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 1,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 16000, linearGain: 0.3536 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 16000, linearGain: 0.3536 }],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 16000, linearGain: 0.3536 }],
					pan: 0,
					panDelay: 0,
					reverb: 19,
					fadeInSeconds: 0,
					fadeOutTicks: -6,
					pulseWidth: 38,
					decimalOffset: 0,
					unison: "inject",
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "swell",
							inverse: false,
							perEnvelopeSpeed: 1.25,
							perEnvelopeLowerBound: 1,
							perEnvelopeUpperBound: 1.5,
							discrete: false,
						},
						{
							target: "pulseWidth",
							envelope: "punch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 1,
							perEnvelopeUpperBound: 0,
							discrete: false,
						},
						{
							target: "panning",
							envelope: "lfo",
							inverse: false,
							perEnvelopeSpeed: 0.5,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 0.9,
							discrete: false,
							waveform: 3,
							steps: 2,
						},
					],
					isDrum: false,
				},
			},
			{
				name: "epic space chip",
				generalMidi: false,
				tags: ["chip", "customchip", "cooltasdude", "lead"],
				settings: {
					type: "custom chip",
					volume: 0,
					eqFilter: [
						{ type: "low-pass", cutoffHz: 5656.85, linearGain: 1.4142 },
						{ type: "high-pass", cutoffHz: 297.3, linearGain: 8 },
						{ type: "peak", cutoffHz: 2000, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 1681.79, linearGain: 2.8284 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 5656.85, linearGain: 1.4142 },
						{ type: "high-pass", cutoffHz: 297.3, linearGain: 8 },
						{ type: "peak", cutoffHz: 2000, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 1681.79, linearGain: 2.8284 },
					],
					eqSubFilters1: [],
					effects: ["panning", "detune", "chorus", "reverb"],
					detuneCents: 0,
					pan: 0,
					panDelay: 10,
					chorus: 86,
					reverb: 45,
					fadeInSeconds: 0,
					fadeOutTicks: -6,
					wave: "square",
					unison: "none",
					customChipWave: {
						"0": -24,
						"1": -24,
						"2": -24,
						"3": -24,
						"4": -24,
						"5": -24,
						"6": -24,
						"7": -24,
						"8": -24,
						"9": -24,
						"10": -24,
						"11": -24,
						"12": -24,
						"13": -24,
						"14": -24,
						"15": -24,
						"16": -24,
						"17": -24,
						"18": -24,
						"19": -24,
						"20": -24,
						"21": -24,
						"22": -24,
						"23": -24,
						"24": -24,
						"25": -24,
						"26": -24,
						"27": 0,
						"28": 0,
						"29": 0,
						"30": 0,
						"31": 0,
						"32": 24,
						"33": 24,
						"34": 24,
						"35": 24,
						"36": 24,
						"37": 24,
						"38": 24,
						"39": 24,
						"40": 0,
						"41": 0,
						"42": 0,
						"43": 0,
						"44": 0,
						"45": 0,
						"46": 0,
						"47": 0,
						"48": 24,
						"49": 24,
						"50": 24,
						"51": 24,
						"52": 24,
						"53": 24,
						"54": 24,
						"55": 24,
						"56": 24,
						"57": 24,
						"58": 24,
						"59": 24,
						"60": 24,
						"61": 24,
						"62": 24,
						"63": 24,
					},
					customChipWaveIntegral: {
						"0": 0,
						"1": 0,
						"2": 0,
						"3": 0,
						"4": 0,
						"5": 0,
						"6": 0,
						"7": 0,
						"8": 0,
						"9": 0,
						"10": 0,
						"11": 0,
						"12": 0,
						"13": 0,
						"14": 0,
						"15": 0,
						"16": 0,
						"17": 0,
						"18": 0,
						"19": 0,
						"20": 0,
						"21": 0,
						"22": 0,
						"23": 0,
						"24": 0,
						"25": 0,
						"26": 0,
						"27": 0,
						"28": 0,
						"29": 0,
						"30": 0,
						"31": 0,
						"32": 0,
						"33": 0,
						"34": 0,
						"35": 0,
						"36": 0,
						"37": 0,
						"38": 0,
						"39": 0,
						"40": 0,
						"41": 0,
						"42": 0,
						"43": 0,
						"44": 0,
						"45": 0,
						"46": 0,
						"47": 0,
						"48": 0,
						"49": 0,
						"50": 0,
						"51": 0,
						"52": 0,
						"53": 0,
						"54": 0,
						"55": 0,
						"56": 0,
						"57": 0,
						"58": 0,
						"59": 0,
						"60": 0,
						"61": 0,
						"62": 0,
						"63": 0,
						"64": 0,
					},
					envelopes: [
						{
							target: "panning",
							envelope: "lfo",
							inverse: true,
							perEnvelopeSpeed: 0.6,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							waveform: 0,
							steps: 2,
						},
					],
					isDrum: false,
				},
			},
			{
				name: "deep bwah",
				generalMidi: false,
				tags: ["fm", "fm4op", "cooltasdude", "dubstep", "bass"],
				settings: {
					type: "FM",
					volume: 0,
					eqFilter: [{ type: "low-pass", cutoffHz: 2000, linearGain: 1.4142 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 2000, linearGain: 1.4142 }],
					eqSubFilters1: [],
					effects: ["panning", "pitch shift", "distortion"],
					pitchShiftSemitones: 13,
					distortion: 57,
					aliases: false,
					pan: 0,
					panDelay: 10,
					fadeInSeconds: 0,
					fadeOutTicks: -24,
					algorithm: "1←(2 3 4)",
					feedbackType: "1⟲",
					feedbackAmplitude: 5,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 9, waveform: "trapezoid", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "operatorAmplitude",
							envelope: "flare",
							inverse: true,
							perEnvelopeSpeed: 7.5,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							index: 2,
						},
						{
							target: "pitchShift",
							envelope: "rise",
							inverse: false,
							perEnvelopeSpeed: 1.3333,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
						},
					],
					isDrum: false,
				},
			},
			{
				name: "night triangle pulse 1",
				generalMidi: false,
				tags: ["chip", "customchip", "cooltasdude", "chiptune"],
				settings: {
					type: "custom chip",
					volume: 0,
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [],
					effects: ["panning", "chord type", "note filter", "chorus", "reverb"],
					chord: "strum",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					strumParts: 1,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [],
					noteSubFilters0: [],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 5656.85, linearGain: 0.5 }],
					pan: 0,
					panDelay: 10,
					chorus: 14,
					reverb: 3,
					fadeInSeconds: 0,
					fadeOutTicks: 96,
					unison: "none",
					wave: "square",
					customChipWave: {
						"0": 16,
						"1": 17,
						"2": 17,
						"3": 17,
						"4": 17,
						"5": 17,
						"6": 17,
						"7": 12,
						"8": 11,
						"9": 9,
						"10": 8,
						"11": 7,
						"12": 5,
						"13": 3,
						"14": 1,
						"15": 0,
						"16": -1,
						"17": -3,
						"18": -5,
						"19": -6,
						"20": -7,
						"21": -9,
						"22": -10,
						"23": -12,
						"24": -13,
						"25": -14,
						"26": -15,
						"27": -16,
						"28": -16,
						"29": -16,
						"30": -16,
						"31": -16,
						"32": -16,
						"33": -16,
						"34": -16,
						"35": -16,
						"36": -16,
						"37": -15,
						"38": -13,
						"39": -12,
						"40": -11,
						"41": -9,
						"42": -7,
						"43": -6,
						"44": -4,
						"45": -3,
						"46": -2,
						"47": 0,
						"48": 1,
						"49": 3,
						"50": 4,
						"51": 6,
						"52": 7,
						"53": 8,
						"54": 9,
						"55": 11,
						"56": 13,
						"57": 14,
						"58": 16,
						"59": 16,
						"60": 16,
						"61": 16,
						"62": 16,
						"63": 16,
					},
					customChipWaveIntegral: {
						"0": 0,
						"1": 0,
						"2": 0,
						"3": 0,
						"4": 0,
						"5": 0,
						"6": 0,
						"7": 0,
						"8": 0,
						"9": 0,
						"10": 0,
						"11": 0,
						"12": 0,
						"13": 0,
						"14": 0,
						"15": 0,
						"16": 0,
						"17": 0,
						"18": 0,
						"19": 0,
						"20": 0,
						"21": 0,
						"22": 0,
						"23": 0,
						"24": 0,
						"25": 0,
						"26": 0,
						"27": 0,
						"28": 0,
						"29": 0,
						"30": 0,
						"31": 0,
						"32": 0,
						"33": 0,
						"34": 0,
						"35": 0,
						"36": 0,
						"37": 0,
						"38": 0,
						"39": 0,
						"40": 0,
						"41": 0,
						"42": 0,
						"43": 0,
						"44": 0,
						"45": 0,
						"46": 0,
						"47": 0,
						"48": 0,
						"49": 0,
						"50": 0,
						"51": 0,
						"52": 0,
						"53": 0,
						"54": 0,
						"55": 0,
						"56": 0,
						"57": 0,
						"58": 0,
						"59": 0,
						"60": 0,
						"61": 0,
						"62": 0,
						"63": 0,
						"64": 0,
					},
					envelopes: [],
					isDrum: false,
				},
			},
			{
				name: "night triangle pulse 2",
				generalMidi: false,
				tags: ["chip", "customchip", "cooltasdude", "chiptune", "featured"],
				settings: {
					type: "custom chip",
					volume: 0,
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [],
					effects: ["panning", "chord type", "note filter", "chorus", "reverb"],
					chord: "strum",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					strumParts: 1,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [],
					noteSubFilters0: [],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 5656.85, linearGain: 0.5 }],
					pan: 0,
					panDelay: 10,
					chorus: 43,
					reverb: 19,
					fadeInSeconds: 0,
					fadeOutTicks: 96,
					unison: "none",
					wave: "square",
					customChipWave: {
						"0": 24,
						"1": 24,
						"2": 24,
						"3": 24,
						"4": 24,
						"5": 24,
						"6": 24,
						"7": 13,
						"8": 11,
						"9": 9,
						"10": 8,
						"11": 7,
						"12": 5,
						"13": 3,
						"14": 1,
						"15": 0,
						"16": -1,
						"17": -3,
						"18": -5,
						"19": -6,
						"20": -7,
						"21": -9,
						"22": -10,
						"23": -12,
						"24": -13,
						"25": -14,
						"26": -15,
						"27": -16,
						"28": 0,
						"29": 0,
						"30": 0,
						"31": 0,
						"32": 0,
						"33": 0,
						"34": 0,
						"35": 0,
						"36": -16,
						"37": -15,
						"38": -13,
						"39": -12,
						"40": -11,
						"41": -9,
						"42": -7,
						"43": -6,
						"44": -4,
						"45": -3,
						"46": -2,
						"47": 0,
						"48": 1,
						"49": 3,
						"50": 4,
						"51": 6,
						"52": 7,
						"53": 8,
						"54": 9,
						"55": 11,
						"56": 13,
						"57": 14,
						"58": 24,
						"59": 24,
						"60": 24,
						"61": 24,
						"62": 24,
						"63": 24,
					},
					customChipWaveIntegral: {
						"0": 0,
						"1": 0,
						"2": 0,
						"3": 0,
						"4": 0,
						"5": 0,
						"6": 0,
						"7": 0,
						"8": 0,
						"9": 0,
						"10": 0,
						"11": 0,
						"12": 0,
						"13": 0,
						"14": 0,
						"15": 0,
						"16": 0,
						"17": 0,
						"18": 0,
						"19": 0,
						"20": 0,
						"21": 0,
						"22": 0,
						"23": 0,
						"24": 0,
						"25": 0,
						"26": 0,
						"27": 0,
						"28": 0,
						"29": 0,
						"30": 0,
						"31": 0,
						"32": 0,
						"33": 0,
						"34": 0,
						"35": 0,
						"36": 0,
						"37": 0,
						"38": 0,
						"39": 0,
						"40": 0,
						"41": 0,
						"42": 0,
						"43": 0,
						"44": 0,
						"45": 0,
						"46": 0,
						"47": 0,
						"48": 0,
						"49": 0,
						"50": 0,
						"51": 0,
						"52": 0,
						"53": 0,
						"54": 0,
						"55": 0,
						"56": 0,
						"57": 0,
						"58": 0,
						"59": 0,
						"60": 0,
						"61": 0,
						"62": 0,
						"63": 0,
						"64": 0,
					},
					envelopes: [],
					isDrum: false,
				},
			},
			{
				name: "FM hard bass",
				generalMidi: false,
				tags: ["fm", "fm4op", "cooltasdude", "bass"],
				settings: {
					type: "FM",
					volume: 0,
					eqFilter: [
						{ type: "low-pass", cutoffHz: 2828.43, linearGain: 0.3536 },
						{
							type: "high-pass",
							cutoffHz: 62.5,
							linearGain: 8,
						},
						{ type: "peak", cutoffHz: 250, linearGain: 0.7071 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 2828.43, linearGain: 0.3536 },
						{
							type: "high-pass",
							cutoffHz: 62.5,
							linearGain: 8,
						},
						{ type: "peak", cutoffHz: 250, linearGain: 0.7071 },
					],
					effects: ["panning", "chord type", "pitch shift", "note filter"],
					chord: "arpeggio",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					monoChordTone: 1,
					pitchShiftSemitones: 12,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 8000, linearGain: 0.0884 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 8000, linearGain: 0.0884 }],
					pan: 0,
					panDelay: 0,
					fadeInSeconds: 0.0263,
					fadeOutTicks: -3,
					algorithm: "(1 2)←(3 4)",
					feedbackType: "1→2→3→4",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "0.75×", amplitude: 13, waveform: "triangle", pulseWidth: 5 },
						{
							frequency: "0.5×",
							amplitude: 12,
							waveform: "pulse width",
							pulseWidth: 6,
						},
						{ frequency: "~2×", amplitude: 6, waveform: "sawtooth", pulseWidth: 5 },
						{ frequency: "3×", amplitude: 0, waveform: "trapezoid", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 8,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "operatorAmplitude",
							envelope: "linear",
							inverse: false,
							perEnvelopeSpeed: 8,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 2,
						},
						{
							target: "feedbackAmplitude",
							envelope: "flare",
							inverse: false,
							perEnvelopeSpeed: 256,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
					isDrum: false,
				},
			},
			{
				name: "alien choir",
				generalMidi: false,
				tags: ["supersaw", "cooltasdude", "vocal"],
				settings: {
					type: "supersaw",
					volume: 0,
					eqFilter: [
						{ type: "low-pass", cutoffHz: 13454.34, linearGain: 0.25 },
						{ type: "high-pass", cutoffHz: 353.55, linearGain: 2 },
						{ type: "peak", cutoffHz: 4756.83, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 3363.59, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 74.33, linearGain: 2.8284 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 13454.34, linearGain: 0.25 },
						{ type: "high-pass", cutoffHz: 353.55, linearGain: 2 },
						{ type: "peak", cutoffHz: 4756.83, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 3363.59, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 74.33, linearGain: 2.8284 },
					],
					effects: ["panning", "note filter", "bitcrusher", "chorus", "reverb"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 11313.71, linearGain: 0.125 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 11313.71, linearGain: 0.125 }],
					bitcrusherOctave: 2.5,
					bitcrusherQuantization: 0,
					pan: 0,
					panDelay: 10,
					chorus: 100,
					reverb: 32,
					fadeInSeconds: 0.0263,
					fadeOutTicks: 48,
					pulseWidth: 50,
					decimalOffset: 0,
					dynamism: 100,
					spread: 50,
					shape: 0,
					envelopes: [
						{
							target: "noteVolume",
							envelope: "punch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "bitcrusherQuantization",
							envelope: "decay",
							inverse: false,
							perEnvelopeSpeed: 4,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
					isDrum: false,
				},
			},
			{
				name: "FM Snare",
				generalMidi: false,
				tags: ["fm", "fm6op", "cooltasdude", "snare"],
				settings: {
					type: "FM6op",
					volume: 0,
					eqFilter: [
						{ type: "peak", cutoffHz: 2378.41, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 3363.59, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 1681.79, linearGain: 0.0884 },
						{ type: "high-pass", cutoffHz: 297.3, linearGain: 1.4142 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "peak", cutoffHz: 2378.41, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 3363.59, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 1681.79, linearGain: 0.0884 },
						{ type: "high-pass", cutoffHz: 297.3, linearGain: 1.4142 },
					],
					eqSubFilters1: [],
					effects: ["panning", "pitch shift", "distortion"],
					pitchShiftSemitones: 24,
					distortion: 100,
					aliases: false,
					pan: 0,
					panDelay: 10,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "1←2←3←4←5←6",
					feedbackType: "1⟲ 2⟲ 3⟲ 4⟲ 5⟲ 6⟲",
					feedbackAmplitude: 15,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "noteVolume",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 10,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "noteVolume",
							envelope: "fall",
							inverse: false,
							perEnvelopeSpeed: 3.5,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "pitchShift",
							envelope: "fall",
							inverse: false,
							perEnvelopeSpeed: 13,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 2,
							discrete: false,
						},
						{
							target: "noteVolume",
							envelope: "linear",
							inverse: false,
							perEnvelopeSpeed: 64,
							perEnvelopeLowerBound: 0.5,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "distortion",
							envelope: "fall",
							inverse: false,
							perEnvelopeSpeed: 64,
							perEnvelopeLowerBound: 0.1,
							perEnvelopeUpperBound: 1.2,
							discrete: false,
						},
						{
							target: "noteVolume",
							envelope: "fall",
							inverse: false,
							perEnvelopeSpeed: 5,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
					isDrum: false,
				},
			},
			{
				name: "subworld bass",
				generalMidi: false,
				tags: ["chip", "customchip", "cooltasdude", "chiptune"],
				settings: {
					type: "custom chip",
					volume: 0,
					eqFilter: [
						{ type: "low-pass", cutoffHz: 840.9, linearGain: 0.7071 },
						{
							type: "high-pass",
							cutoffHz: 74.33,
							linearGain: 0.5,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 840.9, linearGain: 0.7071 },
						{
							type: "high-pass",
							cutoffHz: 74.33,
							linearGain: 0.5,
						},
					],
					effects: ["panning", "transition type", "chorus"],
					transition: "interrupt",
					clicklessTransition: false,
					pan: 0,
					panDelay: 0,
					chorus: 71,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					wave: "square",
					unison: "octave",
					customChipWave: {
						"0": -20,
						"1": -20,
						"2": -20,
						"3": -20,
						"4": -14,
						"5": -14,
						"6": -14,
						"7": -14,
						"8": -8,
						"9": -8,
						"10": -8,
						"11": -8,
						"12": 0,
						"13": 0,
						"14": 0,
						"15": 0,
						"16": 5,
						"17": 5,
						"18": 5,
						"19": 5,
						"20": 0,
						"21": 0,
						"22": 0,
						"23": 0,
						"24": -4,
						"25": -4,
						"26": -4,
						"27": -4,
						"28": -4,
						"29": -4,
						"30": -4,
						"31": -4,
						"32": -24,
						"33": -24,
						"34": -24,
						"35": -24,
						"36": -24,
						"37": -24,
						"38": -24,
						"39": -24,
						"40": -24,
						"41": -24,
						"42": -24,
						"43": -24,
						"44": -24,
						"45": -24,
						"46": -24,
						"47": -24,
						"48": -24,
						"49": -24,
						"50": -24,
						"51": -24,
						"52": -24,
						"53": -24,
						"54": -24,
						"55": -24,
						"56": -24,
						"57": -24,
						"58": -24,
						"59": -24,
						"60": -24,
						"61": -24,
						"62": -24,
						"63": -24,
					},
					customChipWaveIntegral: {
						"0": 0,
						"1": 0,
						"2": 0,
						"3": 0,
						"4": 0,
						"5": 0,
						"6": 0,
						"7": 0,
						"8": 0,
						"9": 0,
						"10": 0,
						"11": 0,
						"12": 0,
						"13": 0,
						"14": 0,
						"15": 0,
						"16": 0,
						"17": 0,
						"18": 0,
						"19": 0,
						"20": 0,
						"21": 0,
						"22": 0,
						"23": 0,
						"24": 0,
						"25": 0,
						"26": 0,
						"27": 0,
						"28": 0,
						"29": 0,
						"30": 0,
						"31": 0,
						"32": 0,
						"33": 0,
						"34": 0,
						"35": 0,
						"36": 0,
						"37": 0,
						"38": 0,
						"39": 0,
						"40": 0,
						"41": 0,
						"42": 0,
						"43": 0,
						"44": 0,
						"45": 0,
						"46": 0,
						"47": 0,
						"48": 0,
						"49": 0,
						"50": 0,
						"51": 0,
						"52": 0,
						"53": 0,
						"54": 0,
						"55": 0,
						"56": 0,
						"57": 0,
						"58": 0,
						"59": 0,
						"60": 0,
						"61": 0,
						"62": 0,
						"63": 0,
						"64": 0,
					},
					envelopes: [],
					isDrum: false,
				},
			},
			{
				name: "hypersonic pluck",
				generalMidi: false,
				tags: ["fm", "fm6op", "cooltasdude", "picked"],
				settings: {
					type: "FM6op",
					volume: 0,
					eqFilter: [
						{ type: "high-pass", cutoffHz: 353.55, linearGain: 4 },
						{
							type: "low-pass",
							cutoffHz: 4000,
							linearGain: 1,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "high-pass", cutoffHz: 353.55, linearGain: 4 },
						{
							type: "low-pass",
							cutoffHz: 4000,
							linearGain: 1,
						},
					],
					eqSubFilters1: [],
					effects: ["panning", "pitch shift", "distortion", "chorus", "reverb"],
					pitchShiftSemitones: 7,
					distortion: 86,
					aliases: false,
					pan: 0,
					panDelay: 10,
					chorus: 57,
					reverb: 23,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "Custom",
					feedbackType: "1⟲ 2⟲",
					feedbackAmplitude: 15,
					customAlgorithm: { mods: [[3], [4], [], [5], [], []], carrierCount: 2 },
					operators: [
						{ frequency: "~1×", amplitude: 15, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 15, waveform: "pulse width", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 15, waveform: "sawtooth", pulseWidth: 5 },
						{ frequency: "0.5×", amplitude: 15, waveform: "sawtooth", pulseWidth: 5 },
						{ frequency: "8×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "noteVolume",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "noteVolume",
							envelope: "fall",
							inverse: false,
							perEnvelopeSpeed: 3.5,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "pitchShift",
							envelope: "fall",
							inverse: false,
							perEnvelopeSpeed: 64,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 2,
							discrete: false,
						},
						{
							target: "noteVolume",
							envelope: "linear",
							inverse: false,
							perEnvelopeSpeed: 6,
							perEnvelopeLowerBound: 0.5,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "distortion",
							envelope: "fall",
							inverse: false,
							perEnvelopeSpeed: 64,
							perEnvelopeLowerBound: 0.1,
							perEnvelopeUpperBound: 1.2,
							discrete: false,
						},
						{
							target: "noteVolume",
							envelope: "fall",
							inverse: false,
							perEnvelopeSpeed: 4,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "operatorAmplitude",
							envelope: "fall",
							inverse: false,
							perEnvelopeSpeed: 40,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 1,
						},
					],
					isDrum: false,
				},
			},
			{
				name: "otherworldly wub",
				generalMidi: false,
				tags: ["chip", "chipwave", "cooltasdude", "pad"],
				settings: {
					type: "chip",
					volume: 0,
					eqFilter: [
						{ type: "low-pass", cutoffHz: 6727.17, linearGain: 0.25 },
						{
							type: "peak",
							cutoffHz: 2828.43,
							linearGain: 0.3536,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 6727.17, linearGain: 0.25 },
						{
							type: "peak",
							cutoffHz: 2828.43,
							linearGain: 0.3536,
						},
					],
					effects: [
						"panning",
						"transition type",
						"chord type",
						"vibrato",
						"note filter",
						"reverb",
					],
					transition: "slide",
					clicklessTransition: false,
					chord: "strum",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					monoChordTone: 1,
					vibrato: "heavy",
					vibratoDepth: 0.45,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 8000, linearGain: 1 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 8000, linearGain: 1 }],
					pan: 0,
					panDelay: 10,
					reverb: 6,
					fadeInSeconds: 0,
					fadeOutTicks: 48,
					wave: "haileybox test1",
					unison: "spinner",
					isUsingAdvancedLoopControls: false,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 3,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "rise",
							inverse: false,
							perEnvelopeSpeed: 9,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
					isDrum: false,
				},
			},
			{
				name: "John Waveform",
				generalMidi: false,
				tags: ["fm", "fm6op", "cooltasdude", "bass"],
				settings: {
					type: "FM6op",
					volume: 0,
					eqFilter: [{ type: "low-pass", cutoffHz: 1469.4, linearGain: 1 }],
					eqFilterType: true,
					eqSimpleCut: 5,
					eqSimplePeak: 3,
					envelopeSpeed: 12,
					eqSubFilters1: [],
					effects: ["panning", "chorus"],
					pan: 0,
					panDelay: 0,
					chorus: 100,
					fadeInSeconds: 0,
					fadeOutTicks: -6,
					algorithm: "1 2←5 (3 4)←6",
					feedbackType: "1→2→3→4→5→6",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "0.75×", amplitude: 8, waveform: "ramp", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 14, waveform: "sine", pulseWidth: 5 },
						{ frequency: "0.5×", amplitude: 11, waveform: "trapezoid", pulseWidth: 5 },
						{ frequency: "~1×", amplitude: 9, waveform: "pulse width", pulseWidth: 3 },
						{ frequency: "2×", amplitude: 7, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 6, waveform: "pulse width", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "operatorAmplitude",
							envelope: "wibble",
							inverse: false,
							perEnvelopeSpeed: 0.2,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 5,
						},
					],
					isDrum: false,
				},
			},
			{
				name: "space saw narrow",
				generalMidi: false,
				tags: ["chip", "chipwave", "cooltasdude"],
				settings: {
					type: "chip",
					volume: 0,
					eqFilter: [{ type: "low-pass", cutoffHz: 4240.89, linearGain: 2 }],
					eqFilterType: true,
					eqSimpleCut: 8,
					eqSimplePeak: 4,
					envelopeSpeed: 12,
					eqSubFilters1: [],
					effects: ["panning", "vibrato", "chorus", "reverb"],
					vibrato: "light",
					vibratoDepth: 0.15,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 0,
					pan: 0,
					panDelay: 0,
					chorus: 29,
					reverb: 0,
					fadeInSeconds: 0.0125,
					fadeOutTicks: 72,
					wave: "zefbox saw narrow",
					unison: "none",
					isUsingAdvancedLoopControls: false,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 11,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [],
					isDrum: false,
				},
			},
			{
				name: "space whisp",
				generalMidi: false,
				tags: ["chip", "chipwave", "cooltasdude"],
				settings: {
					type: "chip",
					volume: 0,
					eqFilter: [
						{ type: "low-pass", cutoffHz: 9513.66, linearGain: 1 },
						{
							type: "peak",
							cutoffHz: 88.39,
							linearGain: 0.5,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 9513.66, linearGain: 1 },
						{
							type: "peak",
							cutoffHz: 88.39,
							linearGain: 0.5,
						},
					],
					effects: ["panning", "note filter", "distortion", "echo"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 4000, linearGain: 0.1768 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 4000, linearGain: 0.1768 }],
					distortion: 0,
					aliases: false,
					pan: 0,
					panDelay: 0,
					echoSustain: 57,
					echoDelayBeats: 0.917,
					fadeInSeconds: 0,
					fadeOutTicks: 6,
					wave: "modbox curved sawtooth",
					unison: "none",
					isUsingAdvancedLoopControls: false,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 4,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "swell",
							inverse: false,
							perEnvelopeSpeed: 8,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "distortion",
							envelope: "linear",
							inverse: false,
							perEnvelopeSpeed: 20,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
					isDrum: false,
				},
			},
			{
				name: "star strings",
				generalMidi: false,
				tags: ["fm", "fm4op", "cooltasdude", "string"],
				settings: {
					type: "FM",
					volume: 0,
					eqFilter: [
						{ type: "low-pass", cutoffHz: 4756.83, linearGain: 0.25 },
						{
							type: "peak",
							cutoffHz: 2828.43,
							linearGain: 5.6569,
						},
						{ type: "peak", cutoffHz: 2378.41, linearGain: 5.6569 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 4756.83, linearGain: 0.25 },
						{
							type: "peak",
							cutoffHz: 2828.43,
							linearGain: 5.6569,
						},
						{ type: "peak", cutoffHz: 2378.41, linearGain: 5.6569 },
					],
					effects: ["panning", "note filter", "chorus", "reverb"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 9513.66, linearGain: 0.7071 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 9513.66, linearGain: 0.7071 }],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 2828.43, linearGain: 0.1768 }],
					noteSubFilters2: [{ type: "low-pass", cutoffHz: 2828.43, linearGain: 0.1768 }],
					noteSubFilters3: [{ type: "low-pass", cutoffHz: 2828.43, linearGain: 0.1768 }],
					pan: 0,
					panDelay: 10,
					chorus: 43,
					reverb: 32,
					fadeInSeconds: 0.0125,
					fadeOutTicks: -3,
					algorithm: "1 2 3←4",
					feedbackType: "1⟲ 2⟲",
					feedbackAmplitude: 1,
					operators: [
						{
							frequency: "0.5×",
							amplitude: 15,
							waveform: "pulse width",
							pulseWidth: 0,
						},
						{ frequency: "0.75×", amplitude: 14, waveform: "sawtooth", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 10, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "3.5×", amplitude: 2, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "punch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "noteVolume",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 20,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "feedbackAmplitude",
							envelope: "decay",
							inverse: false,
							perEnvelopeSpeed: 0.4,
							perEnvelopeLowerBound: 0.9,
							perEnvelopeUpperBound: 1.3,
							discrete: false,
						},
					],
					isDrum: false,
				},
			},
			{
				name: "vibrate pulse 1",
				generalMidi: false,
				tags: ["chip", "customchip", "cooltasdude", "chiptune"],
				settings: {
					type: "custom chip",
					volume: 0,
					eqFilter: [{ type: "low-pass", cutoffHz: 8000, linearGain: 0.5 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 8000, linearGain: 0.5 }],
					effects: ["panning", "pitch shift"],
					pitchShiftSemitones: 13,
					pan: 0,
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: 48,
					wave: "square",
					unison: "custom",
					unisonVoices: 2,
					unisonSpread: 3.5,
					unisonOffset: 7,
					unisonExpression: 0.53,
					unisonSign: 1,
					customChipWave: {
						"0": -24,
						"1": -24,
						"2": -24,
						"3": -24,
						"4": -24,
						"5": -24,
						"6": -24,
						"7": -24,
						"8": -24,
						"9": -24,
						"10": -24,
						"11": 24,
						"12": 24,
						"13": 24,
						"14": 24,
						"15": 24,
						"16": 24,
						"17": 24,
						"18": 24,
						"19": 24,
						"20": 24,
						"21": 24,
						"22": -24,
						"23": -24,
						"24": -24,
						"25": -24,
						"26": -24,
						"27": -24,
						"28": -24,
						"29": -24,
						"30": -24,
						"31": -24,
						"32": 24,
						"33": 24,
						"34": 24,
						"35": 24,
						"36": 24,
						"37": 24,
						"38": 24,
						"39": 24,
						"40": 24,
						"41": 24,
						"42": 24,
						"43": -24,
						"44": -24,
						"45": -24,
						"46": -24,
						"47": -24,
						"48": -24,
						"49": -24,
						"50": -24,
						"51": -24,
						"52": -24,
						"53": -24,
						"54": 0,
						"55": 0,
						"56": 0,
						"57": 0,
						"58": 0,
						"59": 0,
						"60": 0,
						"61": 0,
						"62": 0,
						"63": 0,
					},
					customChipWaveIntegral: {
						"0": 0,
						"1": 0,
						"2": 0,
						"3": 0,
						"4": 0,
						"5": 0,
						"6": 0,
						"7": 0,
						"8": 0,
						"9": 0,
						"10": 0,
						"11": 0,
						"12": 0,
						"13": 0,
						"14": 0,
						"15": 0,
						"16": 0,
						"17": 0,
						"18": 0,
						"19": 0,
						"20": 0,
						"21": 0,
						"22": 0,
						"23": 0,
						"24": 0,
						"25": 0,
						"26": 0,
						"27": 0,
						"28": 0,
						"29": 0,
						"30": 0,
						"31": 0,
						"32": 0,
						"33": 0,
						"34": 0,
						"35": 0,
						"36": 0,
						"37": 0,
						"38": 0,
						"39": 0,
						"40": 0,
						"41": 0,
						"42": 0,
						"43": 0,
						"44": 0,
						"45": 0,
						"46": 0,
						"47": 0,
						"48": 0,
						"49": 0,
						"50": 0,
						"51": 0,
						"52": 0,
						"53": 0,
						"54": 0,
						"55": 0,
						"56": 0,
						"57": 0,
						"58": 0,
						"59": 0,
						"60": 0,
						"61": 0,
						"62": 0,
						"63": 0,
						"64": 0,
					},
					envelopes: [
						{
							target: "pitchShift",
							envelope: "fall",
							inverse: false,
							perEnvelopeSpeed: 40,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
					isDrum: false,
				},
			},
			{
				name: "vibrate pulse 2",
				generalMidi: false,
				tags: ["chip", "customchip", "cooltasdude", "chiptune"],
				settings: {
					type: "custom chip",
					volume: 0,
					eqFilter: [{ type: "low-pass", cutoffHz: 4756.83, linearGain: 0.3536 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 4756.83, linearGain: 0.3536 }],
					effects: [
						"panning",
						"transition type",
						"chord type",
						"vibrato",
						"chorus",
						"reverb",
					],
					transition: "interrupt",
					clicklessTransition: false,
					chord: "strum",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					monoChordTone: 1,
					vibrato: "shaky",
					vibratoDepth: 0.1,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 1,
					pan: 0,
					panDelay: 0,
					chorus: 29,
					reverb: 19,
					fadeInSeconds: 0,
					fadeOutTicks: 48,
					wave: "square",
					unison: "vibrate",
					customChipWave: {
						"0": 0,
						"1": 0,
						"2": 0,
						"3": 0,
						"4": 0,
						"5": 0,
						"6": 0,
						"7": 0,
						"8": 0,
						"9": 0,
						"10": 0,
						"11": 24,
						"12": 24,
						"13": 24,
						"14": 24,
						"15": 24,
						"16": 24,
						"17": 24,
						"18": 24,
						"19": 24,
						"20": 24,
						"21": 24,
						"22": 0,
						"23": 0,
						"24": 0,
						"25": 0,
						"26": 0,
						"27": 0,
						"28": 0,
						"29": 24,
						"30": 24,
						"31": 24,
						"32": 24,
						"33": 24,
						"34": 24,
						"35": 24,
						"36": 24,
						"37": 24,
						"38": 24,
						"39": 24,
						"40": 24,
						"41": 24,
						"42": 24,
						"43": 24,
						"44": 0,
						"45": 0,
						"46": 0,
						"47": 0,
						"48": 0,
						"49": 0,
						"50": 0,
						"51": 24,
						"52": 24,
						"53": 24,
						"54": 24,
						"55": 24,
						"56": 24,
						"57": 24,
						"58": 24,
						"59": 24,
						"60": 24,
						"61": 24,
						"62": 24,
						"63": 24,
					},
					customChipWaveIntegral: {
						"0": 0,
						"1": 0,
						"2": 0,
						"3": 0,
						"4": 0,
						"5": 0,
						"6": 0,
						"7": 0,
						"8": 0,
						"9": 0,
						"10": 0,
						"11": 0,
						"12": 0,
						"13": 0,
						"14": 0,
						"15": 0,
						"16": 0,
						"17": 0,
						"18": 0,
						"19": 0,
						"20": 0,
						"21": 0,
						"22": 0,
						"23": 0,
						"24": 0,
						"25": 0,
						"26": 0,
						"27": 0,
						"28": 0,
						"29": 0,
						"30": 0,
						"31": 0,
						"32": 0,
						"33": 0,
						"34": 0,
						"35": 0,
						"36": 0,
						"37": 0,
						"38": 0,
						"39": 0,
						"40": 0,
						"41": 0,
						"42": 0,
						"43": 0,
						"44": 0,
						"45": 0,
						"46": 0,
						"47": 0,
						"48": 0,
						"49": 0,
						"50": 0,
						"51": 0,
						"52": 0,
						"53": 0,
						"54": 0,
						"55": 0,
						"56": 0,
						"57": 0,
						"58": 0,
						"59": 0,
						"60": 0,
						"61": 0,
						"62": 0,
						"63": 0,
						"64": 0,
					},
					envelopes: [],
					isDrum: false,
				},
			},
			{
				name: "mechanical guitar",
				generalMidi: false,
				tags: ["fm", "fm6op", "cooltasdude", "distortion", "guitar"],
				settings: {
					type: "FM6op",
					volume: 0,
					eqFilter: [{ type: "low-pass", cutoffHz: 5656.85, linearGain: 1.4142 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 5656.85, linearGain: 1.4142 }],
					effects: ["panning"],
					pan: 0,
					panDelay: 10,
					fadeInSeconds: 0,
					fadeOutTicks: 12,
					algorithm: "Custom",
					feedbackType: "Custom",
					feedbackAmplitude: 12,
					customAlgorithm: { mods: [[3, 4], [3], [5], [], [], []], carrierCount: 3 },
					customFeedback: { mods: [[], [4], [], [], [], []] },
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "0.5×", amplitude: 14, waveform: "sawtooth", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 14, waveform: "pulse width", pulseWidth: 4 },
						{ frequency: "1×", amplitude: 11, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "3.5×", amplitude: 12, waveform: "quasi-sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [],
					isDrum: false,
				},
			},
			{
				name: "exosphere",
				generalMidi: false,
				tags: ["pwm", "cooltasdude", "featured"],
				settings: {
					type: "PWM",
					volume: 0,
					eqFilter: [{ type: "low-pass", cutoffHz: 4787.19, linearGain: 1 }],
					eqFilterType: true,
					eqSimpleCut: 8,
					eqSimplePeak: 2,
					envelopeSpeed: 12,
					eqSubFilters1: [],
					effects: [
						"panning",
						"transition type",
						"note filter",
						"distortion",
						"bitcrusher",
						"chorus",
						"echo",
						"reverb",
					],
					transition: "interrupt",
					clicklessTransition: false,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 11313.71, linearGain: 0.0884 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 11313.71, linearGain: 0.0884 }],
					distortion: 86,
					aliases: false,
					bitcrusherOctave: 6.5,
					bitcrusherQuantization: 0,
					pan: 0,
					panDelay: 0,
					chorus: 86,
					echoSustain: 71,
					echoDelayBeats: 0.75,
					reverb: 13,
					fadeInSeconds: 0,
					fadeOutTicks: 6,
					pulseWidth: 50,
					decimalOffset: 0,
					unison: "fifth",
					envelopes: [],
					isDrum: false,
				},
			},
			{
				name: "activated pulse",
				generalMidi: false,
				tags: ["chip", "customchip", "cooltasdude", "chiptune"],
				settings: {
					type: "custom chip",
					volume: 0,
					eqFilter: [
						{ type: "low-pass", cutoffHz: 6727.17, linearGain: 0.5 },
						{
							type: "high-pass",
							cutoffHz: 297.3,
							linearGain: 0.25,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 6727.17, linearGain: 0.5 },
						{
							type: "high-pass",
							cutoffHz: 297.3,
							linearGain: 0.25,
						},
					],
					effects: ["panning", "transition type", "chorus", "echo", "reverb"],
					transition: "interrupt",
					clicklessTransition: false,
					pan: 0,
					panDelay: 10,
					chorus: 86,
					echoSustain: 43,
					echoDelayBeats: 0.583,
					reverb: 23,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					wave: "double pulse",
					unison: "none",
					customChipWave: {
						"0": -24,
						"1": -24,
						"2": -24,
						"3": -24,
						"4": -24,
						"5": -24,
						"6": -24,
						"7": -24,
						"8": -24,
						"9": -24,
						"10": -24,
						"11": -24,
						"12": -24,
						"13": -24,
						"14": -24,
						"15": -24,
						"16": -24,
						"17": -24,
						"18": -24,
						"19": -24,
						"20": -24,
						"21": -24,
						"22": -24,
						"23": 24,
						"24": 24,
						"25": 24,
						"26": 24,
						"27": 24,
						"28": 24,
						"29": 24,
						"30": 24,
						"31": 24,
						"32": 24,
						"33": 24,
						"34": 24,
						"35": 24,
						"36": 24,
						"37": 24,
						"38": 24,
						"39": 24,
						"40": 24,
						"41": 24,
						"42": 24,
						"43": 24,
						"44": 24,
						"45": 24,
						"46": 24,
						"47": 24,
						"48": 24,
						"49": 24,
						"50": 24,
						"51": 24,
						"52": 24,
						"53": 24,
						"54": 24,
						"55": 24,
						"56": 24,
						"57": 24,
						"58": 24,
						"59": 24,
						"60": 24,
						"61": 24,
						"62": 24,
						"63": 24,
					},
					customChipWaveIntegral: {
						"0": 0,
						"1": 0,
						"2": 0,
						"3": 0,
						"4": 0,
						"5": 0,
						"6": 0,
						"7": 0,
						"8": 0,
						"9": 0,
						"10": 0,
						"11": 0,
						"12": 0,
						"13": 0,
						"14": 0,
						"15": 0,
						"16": 0,
						"17": 0,
						"18": 0,
						"19": 0,
						"20": 0,
						"21": 0,
						"22": 0,
						"23": 0,
						"24": 0,
						"25": 0,
						"26": 0,
						"27": 0,
						"28": 0,
						"29": 0,
						"30": 0,
						"31": 0,
						"32": 0,
						"33": 0,
						"34": 0,
						"35": 0,
						"36": 0,
						"37": 0,
						"38": 0,
						"39": 0,
						"40": 0,
						"41": 0,
						"42": 0,
						"43": 0,
						"44": 0,
						"45": 0,
						"46": 0,
						"47": 0,
						"48": 0,
						"49": 0,
						"50": 0,
						"51": 0,
						"52": 0,
						"53": 0,
						"54": 0,
						"55": 0,
						"56": 0,
						"57": 0,
						"58": 0,
						"59": 0,
						"60": 0,
						"61": 0,
						"62": 0,
						"63": 0,
						"64": 0,
					},
					envelopes: [],
					isDrum: false,
				},
			},
			{
				name: "dramatic strums",
				generalMidi: false,
				tags: ["supersaw", "cooltasdude"],
				settings: {
					type: "supersaw",
					volume: 0,
					eqFilter: [
						{ type: "high-pass", cutoffHz: 594.6, linearGain: 0.5 },
						{
							type: "peak",
							cutoffHz: 5656.85,
							linearGain: 0.0884,
						},
						{ type: "peak", cutoffHz: 8000, linearGain: 2.8284 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "high-pass", cutoffHz: 594.6, linearGain: 0.5 },
						{
							type: "peak",
							cutoffHz: 5656.85,
							linearGain: 0.0884,
						},
						{ type: "peak", cutoffHz: 8000, linearGain: 2.8284 },
					],
					effects: [
						"panning",
						"chord type",
						"detune",
						"note filter",
						"chorus",
						"echo",
						"reverb",
					],
					chord: "strum",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					monoChordTone: 1,
					detuneCents: 24,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 2378.41, linearGain: 0.5 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 2378.41, linearGain: 0.5 }],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 2378.41, linearGain: 1 }],
					pan: 0,
					panDelay: 10,
					chorus: 71,
					echoSustain: 86,
					echoDelayBeats: 0.667,
					reverb: 84,
					fadeInSeconds: 0,
					fadeOutTicks: 48,
					pulseWidth: 50,
					decimalOffset: 0,
					dynamism: 100,
					spread: 50,
					shape: 0,
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 2,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "noteVolume",
							envelope: "note size",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "detune",
							envelope: "pitch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							pitchEnvelopeStart: 0,
							pitchEnvelopeEnd: 96,
						},
					],
					isDrum: false,
				},
			},
			{
				name: "electric sand guitar",
				generalMidi: false,
				tags: ["fm", "fm4op", "cooltasdude"],
				settings: {
					type: "FM",
					volume: 0,
					eqFilter: [
						{ type: "low-pass", cutoffHz: 8000, linearGain: 0.125 },
						{
							type: "high-pass",
							cutoffHz: 297.3,
							linearGain: 0.1768,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 8000, linearGain: 0.125 },
						{
							type: "high-pass",
							cutoffHz: 297.3,
							linearGain: 0.1768,
						},
					],
					effects: ["panning", "distortion", "bitcrusher", "reverb"],
					distortion: 71,
					aliases: false,
					bitcrusherOctave: 5,
					bitcrusherQuantization: 0,
					pan: 0,
					panDelay: 0,
					reverb: 3,
					fadeInSeconds: 0,
					fadeOutTicks: -3,
					algorithm: "1 2←(3 4)",
					feedbackType: "4⟲",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "0.5×", amplitude: 13, waveform: "sine", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 14, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "15×", amplitude: 4, waveform: "pulse width", pulseWidth: 8 },
						{ frequency: "~1×", amplitude: 1, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "operatorAmplitude",
							envelope: "fall",
							inverse: false,
							perEnvelopeSpeed: 5.5,
							perEnvelopeLowerBound: 0.1,
							perEnvelopeUpperBound: 0.9,
							discrete: false,
							index: 3,
						},
					],
					isDrum: false,
				},
			},
			{
				name: "flattened pulse",
				generalMidi: false,
				tags: ["pwm", "cooltasdude"],
				settings: {
					type: "PWM",
					volume: 0,
					eqFilter: [{ type: "low-pass", cutoffHz: 2110.37, linearGain: 1.4142 }],
					eqFilterType: true,
					eqSimpleCut: 6,
					eqSimplePeak: 3,
					envelopeSpeed: 12,
					eqSubFilters1: [],
					effects: ["panning", "chorus", "reverb"],
					pan: 0,
					panDelay: 0,
					chorus: 57,
					reverb: 35,
					fadeInSeconds: 0,
					fadeOutTicks: -3,
					pulseWidth: 38,
					decimalOffset: 0,
					unison: "detune",
					envelopes: [],
					isDrum: false,
				},
			},
			{
				name: "harmonic bass",
				generalMidi: false,
				tags: ["harmonics", "cooltasdude"],
				settings: {
					type: "harmonics",
					volume: 0,
					eqFilter: [{ type: "low-pass", cutoffHz: 8000, linearGain: 0.5 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 8000, linearGain: 0.5 }],
					effects: [
						"panning",
						"transition type",
						"chord type",
						"note filter",
						"bitcrusher",
						"reverb",
					],
					transition: "slide",
					clicklessTransition: false,
					chord: "strum",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					monoChordTone: 1,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 13454.34, linearGain: 0.1768 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 13454.34, linearGain: 0.1768 }],
					bitcrusherOctave: 6,
					bitcrusherQuantization: 71,
					pan: 0,
					panDelay: 0,
					reverb: 3,
					fadeInSeconds: 0,
					fadeOutTicks: 6,
					harmonics: [
						86, 71, 100, 86, 57, 86, 100, 71, 86, 57, 86, 86, 71, 57, 57, 57, 43, 43,
						43, 57, 57, 43, 43, 43, 29, 29, 29, 29,
					],
					unison: "none",
					envelopes: [
						{
							target: "panning",
							envelope: "pitch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 1,
							perEnvelopeUpperBound: 0.5,
							discrete: false,
							pitchEnvelopeStart: 14,
							pitchEnvelopeEnd: 36,
						},
						{
							target: "panning",
							envelope: "pitch",
							inverse: true,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0.5,
							perEnvelopeUpperBound: 1,
							discrete: false,
							pitchEnvelopeStart: 14,
							pitchEnvelopeEnd: 36,
						},
					],
					isDrum: false,
				},
			},
			{
				name: "shell whistle",
				generalMidi: false,
				tags: ["pickedstring", "cooltasdude"],
				settings: {
					type: "Picked String",
					volume: 0,
					eqFilter: [
						{ type: "low-pass", cutoffHz: 8000, linearGain: 2 },
						{
							type: "peak",
							cutoffHz: 2378.41,
							linearGain: 0.3536,
						},
						{ type: "peak", cutoffHz: 594.6, linearGain: 2 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 8000, linearGain: 2 },
						{
							type: "peak",
							cutoffHz: 2378.41,
							linearGain: 0.3536,
						},
						{ type: "peak", cutoffHz: 594.6, linearGain: 2 },
					],
					effects: [
						"panning",
						"chord type",
						"pitch shift",
						"note filter",
						"chorus",
						"reverb",
					],
					chord: "strum",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					monoChordTone: 1,
					pitchShiftSemitones: 12,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [],
					noteSubFilters0: [],
					pan: 0,
					panDelay: 0,
					chorus: 86,
					reverb: 3,
					fadeInSeconds: 0.0938,
					fadeOutTicks: 12,
					harmonics: [
						71, 0, 0, 0, 43, 0, 14, 86, 0, 0, 14, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
						100, 0, 57, 0, 14,
					],
					unison: "inject",
					stringSustain: 57,
					envelopes: [
						{
							target: "chorus",
							envelope: "swell",
							inverse: true,
							perEnvelopeSpeed: 10,
							perEnvelopeLowerBound: 0.9,
							perEnvelopeUpperBound: 1.1,
							discrete: false,
						},
						{
							target: "none",
							envelope: "none",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
					isDrum: false,
				},
			},
			{
				name: "blent chip",
				generalMidi: false,
				tags: ["chip", "chipwave", "cooltasdude"],
				settings: {
					type: "chip",
					volume: 0,
					eqFilter: [
						{ type: "low-pass", cutoffHz: 8000, linearGain: 2.8284 },
						{
							type: "peak",
							cutoffHz: 4000,
							linearGain: 2,
						},
						{ type: "peak", cutoffHz: 1414.21, linearGain: 0.7071 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 28,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 8000, linearGain: 2.8284 },
						{
							type: "peak",
							cutoffHz: 4000,
							linearGain: 2,
						},
						{ type: "peak", cutoffHz: 1414.21, linearGain: 0.7071 },
					],
					effects: ["panning", "note filter", "chorus", "echo"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 9513.66, linearGain: 0.0884 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 9513.66, linearGain: 0.0884 }],
					pan: 0,
					panDelay: 0,
					chorus: 57,
					echoSustain: 29,
					echoDelayBeats: 0.5,
					fadeInSeconds: 0,
					fadeOutTicks: -6,
					wave: "glitch",
					unison: "none",
					isUsingAdvancedLoopControls: false,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 224,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "linear",
							inverse: false,
							perEnvelopeSpeed: 0.04,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
					isDrum: false,
				},
			},
			{
				name: "slidey saw",
				generalMidi: false,
				tags: ["harmonics", "cooltasdude"],
				settings: {
					type: "harmonics",
					volume: 0,
					eqFilter: [{ type: "low-pass", cutoffHz: 5656.85, linearGain: 0.7071 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 5656.85, linearGain: 0.7071 }],
					effects: [
						"panning",
						"transition type",
						"pitch shift",
						"vibrato",
						"note filter",
						"distortion",
						"chorus",
					],
					transition: "slide",
					clicklessTransition: false,
					pitchShiftSemitones: 0,
					vibrato: "shaky",
					vibratoDepth: 0.1,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 1,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "low-pass", cutoffHz: 8000, linearGain: 5.6569 },
						{
							type: "high-pass",
							cutoffHz: 420.45,
							linearGain: 2,
						},
					],
					noteSubFilters0: [
						{ type: "low-pass", cutoffHz: 8000, linearGain: 5.6569 },
						{
							type: "high-pass",
							cutoffHz: 420.45,
							linearGain: 2,
						},
					],
					distortion: 100,
					aliases: false,
					pan: 0,
					panDelay: 10,
					chorus: 100,
					fadeInSeconds: 0,
					fadeOutTicks: 6,
					harmonics: [
						29, 14, 14, 14, 14, 14, 29, 14, 29, 29, 29, 57, 43, 57, 86, 100, 71, 14, 14,
						29, 14, 14, 14, 0, 14, 0, 0, 0,
					],
					unison: "none",
					envelopes: [],
					isDrum: false,
				},
			},
			{
				name: "focused crystal",
				generalMidi: false,
				tags: ["fm", "fm4op", "cooltasdude", "featured"],
				settings: {
					type: "FM",
					volume: 0,
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [],
					effects: [
						"transition type",
						"vibrato",
						"note filter",
						"chorus",
						"echo",
						"reverb",
					],
					transition: "normal",
					clicklessTransition: false,
					vibrato: "delayed",
					vibratoDepth: 0.3,
					vibratoDelay: 18.5,
					vibratoSpeed: 10,
					vibratoType: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 4756.83, linearGain: 0.7071 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 4756.83, linearGain: 0.7071 }],
					chorus: 29,
					echoSustain: 43,
					echoDelayBeats: 1.083,
					reverb: 68,
					fadeInSeconds: 0,
					fadeOutTicks: 24,
					algorithm: "1 2 3 4",
					feedbackType: "1⟲ 2⟲ 3⟲ 4⟲",
					feedbackAmplitude: 4,
					operators: [
						{ frequency: "1×", amplitude: 11, waveform: "sine", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 6, waveform: "sine", pulseWidth: 5 },
						{ frequency: "4×", amplitude: 5, waveform: "sine", pulseWidth: 5 },
						{ frequency: "6×", amplitude: 3, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{ target: "noteFilterAllFreqs", envelope: "twang 3" },
						{
							target: "feedbackAmplitude",
							envelope: "twang 1",
						},
					],
					isDrum: false,
				},
			},
			{
				name: "monument",
				generalMidi: false,
				tags: ["chip", "chipwave", "cooltasdude"],
				settings: {
					type: "chip",
					volume: 0,
					eqFilter: [
						{ type: "low-pass", cutoffHz: 3363.59, linearGain: 2 },
						{ type: "peak", cutoffHz: 500, linearGain: 0.125 },
						{ type: "peak", cutoffHz: 210.22, linearGain: 5.6569 },
						{ type: "peak", cutoffHz: 840.9, linearGain: 5.6569 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 3363.59, linearGain: 2 },
						{ type: "peak", cutoffHz: 500, linearGain: 0.125 },
						{ type: "peak", cutoffHz: 210.22, linearGain: 5.6569 },
						{ type: "peak", cutoffHz: 840.9, linearGain: 5.6569 },
					],
					effects: [
						"panning",
						"transition type",
						"chord type",
						"distortion",
						"chorus",
						"echo",
						"reverb",
					],
					transition: "normal",
					clicklessTransition: false,
					chord: "strum",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					monoChordTone: 1,
					distortion: 0,
					aliases: false,
					pan: 0,
					panDelay: 10,
					chorus: 86,
					echoSustain: 29,
					echoDelayBeats: 1,
					reverb: 35,
					fadeInSeconds: 0.0413,
					fadeOutTicks: 12,
					wave: "modbox pnryshk a (u5)",
					unison: "octave",
					isUsingAdvancedLoopControls: false,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 11,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [
						{
							target: "noteVolume",
							envelope: "punch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0.8,
							perEnvelopeUpperBound: 1.4,
							discrete: false,
						},
						{
							target: "noteVolume",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 1,
							perEnvelopeUpperBound: 1.3,
							discrete: false,
						},
					],
					isDrum: false,
				},
			},
			{
				name: "boosted synth kick",
				generalMidi: false,
				tags: ["fm", "fm4op", "cooltasdude", "kick"],
				settings: {
					type: "FM",
					volume: 0,
					eqFilter: [{ type: "low-pass", cutoffHz: 6727.17, linearGain: 0.25 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 6727.17, linearGain: 0.25 }],
					effects: ["panning", "detune"],
					detuneCents: 0,
					pan: 0,
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -3,
					algorithm: "1←(2 3 4)",
					feedbackType: "1⟲",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "6×", amplitude: 15, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "operatorFrequency",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 24,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 0,
						},
						{
							target: "noteVolume",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 8,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "operatorFrequency",
							envelope: "note size",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 0,
						},
					],
					isDrum: false,
				},
			},
			{
				name: "electric gitrumpet 2",
				generalMidi: false,
				tags: ["fm", "fm4op", "cooltasdude"],
				settings: {
					type: "FM",
					volume: 0,
					eqFilter: [{ type: "low-pass", cutoffHz: 4756.83, linearGain: 1.4142 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 4756.83, linearGain: 1.4142 }],
					eqSubFilters1: [],
					effects: [
						"panning",
						"detune",
						"vibrato",
						"note filter",
						"distortion",
						"chorus",
						"reverb",
					],
					detuneCents: 0,
					vibrato: "custom",
					vibratoDepth: 0.68,
					vibratoDelay: 17,
					vibratoSpeed: 12,
					vibratoType: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "low-pass", cutoffHz: 13454.34, linearGain: 0.5 },
						{
							type: "peak",
							cutoffHz: 3363.59,
							linearGain: 0.1768,
						},
						{ type: "high-pass", cutoffHz: 1000, linearGain: 0.1768 },
					],
					noteSubFilters0: [
						{ type: "low-pass", cutoffHz: 13454.34, linearGain: 0.5 },
						{
							type: "peak",
							cutoffHz: 3363.59,
							linearGain: 0.1768,
						},
						{ type: "high-pass", cutoffHz: 1000, linearGain: 0.1768 },
					],
					distortion: 100,
					aliases: false,
					pan: 0,
					panDelay: 0,
					chorus: 43,
					reverb: 13,
					fadeInSeconds: 0.0263,
					fadeOutTicks: -3,
					algorithm: "1 2←(3 4)",
					feedbackType: "1⟲",
					feedbackAmplitude: 9,
					operators: [
						{
							frequency: "0.75×",
							amplitude: 14,
							waveform: "pulse width",
							pulseWidth: 2,
						},
						{ frequency: "1×", amplitude: 14, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 8, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 5, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "operatorAmplitude",
							envelope: "flare",
							inverse: false,
							perEnvelopeSpeed: 8,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 3,
						},
						{
							target: "feedbackAmplitude",
							envelope: "swell",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "operatorFrequency",
							envelope: "decay",
							inverse: false,
							perEnvelopeSpeed: 128,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 0,
						},
						{
							target: "noteFilterFreq",
							envelope: "swell",
							inverse: false,
							perEnvelopeSpeed: 2.5,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 2,
						},
						{
							target: "noteVolume",
							envelope: "note size",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "detune",
							envelope: "note size",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
					isDrum: false,
				},
			},
			{
				name: "epic vibes supersaw",
				generalMidi: false,
				tags: ["chip", "chipwave", "cooltasdude"],
				settings: {
					type: "chip",
					volume: 0,
					eqFilter: [
						{ type: "low-pass", cutoffHz: 3363.59, linearGain: 0.3536 },
						{
							type: "peak",
							cutoffHz: 125,
							linearGain: 1.4142,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 3363.59, linearGain: 0.3536 },
						{
							type: "peak",
							cutoffHz: 125,
							linearGain: 1.4142,
						},
					],
					effects: [
						"panning",
						"chord type",
						"vibrato",
						"note filter",
						"distortion",
						"reverb",
					],
					chord: "strum",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					monoChordTone: 1,
					vibrato: "delayed",
					vibratoDepth: 0.3,
					vibratoDelay: 18.5,
					vibratoSpeed: 10,
					vibratoType: 0,
					noteFilterType: true,
					noteSimpleCut: 8,
					noteSimplePeak: 2,
					noteFilter: [{ type: "low-pass", cutoffHz: 4787.19, linearGain: 1 }],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 4787.19, linearGain: 1 }],
					distortion: 71,
					aliases: false,
					pan: 0,
					panDelay: 0,
					reverb: 10,
					fadeInSeconds: 0.0125,
					fadeOutTicks: -6,
					wave: "zefbox saw wide",
					unison: "fifth",
					isUsingAdvancedLoopControls: false,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 11,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [],
					isDrum: false,
				},
			},
			{
				name: "execute pulse",
				generalMidi: false,
				tags: ["pwm", "cooltasdude"],
				settings: {
					type: "PWM",
					volume: 0,
					eqFilter: [
						{ type: "low-pass", cutoffHz: 11313.71, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 9513.66, linearGain: 0.3536 },
						{ type: "peak", cutoffHz: 2378.41, linearGain: 2 },
						{ type: "peak", cutoffHz: 3363.59, linearGain: 1.4142 },
						{ type: "high-pass", cutoffHz: 88.39, linearGain: 1 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 11313.71, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 9513.66, linearGain: 0.3536 },
						{ type: "peak", cutoffHz: 2378.41, linearGain: 2 },
						{ type: "peak", cutoffHz: 3363.59, linearGain: 1.4142 },
						{ type: "high-pass", cutoffHz: 88.39, linearGain: 1 },
					],
					effects: ["panning", "detune", "note filter", "reverb"],
					detuneCents: 12,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 6727.17, linearGain: 0.125 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 6727.17, linearGain: 0.125 }],
					pan: 0,
					panDelay: 17,
					reverb: 26,
					fadeInSeconds: 0,
					fadeOutTicks: 24,
					unison: "custom",
					unisonVoices: 1,
					unisonSpread: 1,
					unisonOffset: 1,
					unisonExpression: 1.4,
					unisonSign: -0.5,
					unisonBuzzes: false,
					pulseWidth: 44,
					decimalOffset: 0,
					envelopes: [
						{ target: "noteFilterAllFreqs", envelope: "punch" },
						{ target: "noteVolume", envelope: "twang 2" },
						{ target: "unison", envelope: "twang 1" },
						{ target: "unison", envelope: "twang 1" },
						{ target: "unison", envelope: "twang 1" },
						{ target: "unison", envelope: "twang 1" },
						{ target: "unison", envelope: "twang 1" },
					],
					isDrum: false,
				},
			},
			{
				name: "execute lead",
				generalMidi: false,
				tags: ["chip", "chipwave", "cooltasdude"],
				settings: {
					type: "chip",
					volume: 0,
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 0,
					eqSubFilters0: [],
					effects: [
						"panning",
						"transition type",
						"chord type",
						"vibrato",
						"note filter",
						"chorus",
					],
					transition: "normal",
					clicklessTransition: false,
					chord: "arpeggio",
					fastTwoNoteArp: true,
					arpeggioSpeed: 9,
					vibrato: "none",
					vibratoDepth: 0,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 0,
					noteFilterType: true,
					noteSimpleCut: 8,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 16000, linearGain: 0.3536 }],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 16000, linearGain: 0.3536 }],
					pan: 0,
					panDelay: 10,
					chorus: 29,
					fadeInSeconds: 0,
					fadeOutTicks: 72,
					unison: "custom",
					unisonVoices: 2,
					unisonSpread: 0,
					unisonOffset: 0,
					unisonExpression: 1,
					unisonSign: 1,
					unisonBuzzes: false,
					wave: "modbox pnryshk a (u5)",
					isUsingAdvancedLoopControls: false,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 11,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [{ target: "noteFilterAllFreqs", envelope: "decay 2" }],
					isDrum: false,
				},
			},
			{
				name: "execute whisp",
				generalMidi: false,
				tags: ["chip", "chipwave", "cooltasdude"],
				settings: {
					type: "chip",
					volume: 0,
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: [
						"panning",
						"transition type",
						"chord type",
						"vibrato",
						"note filter",
						"chorus",
					],
					transition: "normal",
					clicklessTransition: false,
					chord: "arpeggio",
					fastTwoNoteArp: true,
					arpeggioSpeed: 9,
					vibrato: "none",
					vibratoDepth: 0,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 0,
					noteFilterType: true,
					noteSimpleCut: 8,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 16000, linearGain: 0.3536 }],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 16000, linearGain: 0.3536 }],
					pan: 0,
					panDelay: 10,
					chorus: 29,
					fadeInSeconds: 0.1575,
					fadeOutTicks: 96,
					unison: "custom",
					unisonVoices: 1,
					unisonSpread: 0,
					unisonOffset: 0,
					unisonExpression: 1,
					unisonSign: 1,
					unisonBuzzes: false,
					wave: "zefbox pulse",
					isUsingAdvancedLoopControls: false,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 9,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [{ target: "noteFilterAllFreqs", envelope: "decay 2" }],
					isDrum: false,
				},
			},
			// Jukebox 0.0.2
			{
				name: "powered noise",
				generalMidi: false,
				tags: ["noise", "cooltasdude"],
				settings: {
					type: "noise",
					volume: 0,
					eqFilter: [
						{ type: "low-pass", cutoffHz: 8000, linearGain: 0.1768 },
						{
							type: "high-pass",
							cutoffHz: 88.39,
							linearGain: 0.3536,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 8000, linearGain: 0.1768 },
						{
							type: "high-pass",
							cutoffHz: 88.39,
							linearGain: 0.3536,
						},
					],
					effects: ["panning", "transition type"],
					transition: "interrupt",
					clicklessTransition: false,
					pan: 0,
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: 48,
					wave: "1-bit metallic",
					unison: "custom",
					unisonVoices: 2,
					unisonSpread: 0.036,
					unisonOffset: -36,
					unisonExpression: 0.6,
					unisonSign: 1,
					envelopes: [],
					isDrum: false,
				},
			},
			{
				name: "adventure pulse",
				generalMidi: false,
				tags: ["chip", "chipwave", "cooltasdude"],
				settings: {
					type: "chip",
					volume: 0,
					eqFilter: [{ type: "low-pass", cutoffHz: 6727.17, linearGain: 1 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 6727.17, linearGain: 1 }],
					effects: ["transition type", "vibrato"],
					transition: "interrupt",
					clicklessTransition: false,
					vibrato: "delayed",
					vibratoDepth: 0.3,
					vibratoDelay: 18.5,
					vibratoSpeed: 10,
					vibratoType: 0,
					fadeInSeconds: 0,
					fadeOutTicks: 72,
					wave: "1/8 pulse",
					unison: "fifth",
					isUsingAdvancedLoopControls: false,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 2,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [],
					isDrum: false,
				},
			},
			// Jukebox 0.0.3
			{
				name: "uncertainty pad",
				generalMidi: false,
				tags: ["fm", "fm6op", "cooltasdude", "pad"],
				settings: {
					type: "FM6op",
					volume: 0,
					eqFilter: [{ type: "low-pass", cutoffHz: 4756.83, linearGain: 1 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 4756.83, linearGain: 1 }],
					effects: ["panning", "vibrato", "note filter", "chorus", "reverb"],
					vibrato: "delayed",
					vibratoDepth: 0.3,
					vibratoDelay: 18.5,
					vibratoSpeed: 10,
					vibratoType: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "high-pass", cutoffHz: 353.55, linearGain: 2.8284 },
						{
							type: "low-pass",
							cutoffHz: 5656.85,
							linearGain: 0.7071,
						},
					],
					noteSubFilters0: [
						{ type: "high-pass", cutoffHz: 353.55, linearGain: 2.8284 },
						{
							type: "low-pass",
							cutoffHz: 5656.85,
							linearGain: 0.7071,
						},
					],
					pan: 0,
					panDelay: 0,
					chorus: 43,
					reverb: 3,
					fadeInSeconds: 0,
					fadeOutTicks: 72,
					algorithm: "Custom",
					feedbackType: "Custom",
					feedbackAmplitude: 12,
					customAlgorithm: { mods: [[3], [3], [], [6], [6], []], carrierCount: 5 },
					customFeedback: { mods: [[], [], [], [5], [], []] },
					operators: [
						{ frequency: "1×", amplitude: 13, waveform: "sine", pulseWidth: 5 },
						{ frequency: "0.5×", amplitude: 12, waveform: "sine", pulseWidth: 5 },
						{ frequency: "9×", amplitude: 12, waveform: "sine", pulseWidth: 5 },
						{ frequency: "6×", amplitude: 12, waveform: "sine", pulseWidth: 5 },
						{ frequency: "0.75×", amplitude: 13, waveform: "sine", pulseWidth: 5 },
						{ frequency: "0.75×", amplitude: 10, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "noteVolume",
							envelope: "swell",
							inverse: false,
							perEnvelopeSpeed: 1.3333,
							perEnvelopeLowerBound: 0.2,
							perEnvelopeUpperBound: 0.3,
							discrete: false,
						},
					],
					isDrum: false,
				},
			},
			{
				name: "ominous pulse lead",
				generalMidi: false,
				tags: ["pwm", "cooltasdude"],
				settings: {
					type: "PWM",
					volume: 0,
					eqFilter: [
						{ type: "low-pass", cutoffHz: 9513.66, linearGain: 0.25 },
						{
							type: "peak",
							cutoffHz: 1189.21,
							linearGain: 0.5,
						},
						{ type: "peak", cutoffHz: 2000, linearGain: 0.3536 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 9513.66, linearGain: 0.25 },
						{
							type: "peak",
							cutoffHz: 1189.21,
							linearGain: 0.5,
						},
						{ type: "peak", cutoffHz: 2000, linearGain: 0.3536 },
					],
					effects: ["panning", "echo"],
					pan: 0,
					panDelay: 0,
					echoSustain: 57,
					echoDelayBeats: 1.167,
					fadeInSeconds: 0.0125,
					fadeOutTicks: -1,
					pulseWidth: 49,
					decimalOffset: 0,
					unison: "warbled",
					envelopes: [],
					isDrum: false,
				},
			},
			{
				name: "max sawtooth lead",
				generalMidi: false,
				tags: ["chip", "chipwave", "cooltasdude"],
				settings: {
					type: "chip",
					volume: 0,
					eqFilter: [{ type: "low-pass", cutoffHz: 6727.17, linearGain: 1 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 6727.17, linearGain: 1 }],
					effects: ["panning", "vibrato", "chorus", "echo", "reverb"],
					vibrato: "light",
					vibratoDepth: 0.15,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 0,
					pan: 0,
					panDelay: 0,
					chorus: 43,
					echoSustain: 43,
					echoDelayBeats: 1,
					reverb: 61,
					fadeInSeconds: 0.0125,
					fadeOutTicks: 72,
					wave: "sawtooth",
					unison: "custom",
					unisonVoices: 2,
					unisonSpread: 6.068,
					unisonOffset: 6,
					unisonExpression: 0.8,
					unisonSign: 1,
					isUsingAdvancedLoopControls: false,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 32,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [],
					isDrum: false,
				},
			},
			{
				name: "crystal ice",
				generalMidi: false,
				tags: ["chip", "customchip", "cooltasdude"],
				settings: {
					type: "custom chip",
					volume: 0,
					eqFilter: [
						{ type: "peak", cutoffHz: 2378.41, linearGain: 0.25 },
						{
							type: "peak",
							cutoffHz: 594.6,
							linearGain: 4,
						},
						{ type: "high-pass", cutoffHz: 105.11, linearGain: 0.25 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 5,
					eqSubFilters0: [
						{ type: "peak", cutoffHz: 2378.41, linearGain: 0.25 },
						{
							type: "peak",
							cutoffHz: 594.6,
							linearGain: 4,
						},
						{ type: "high-pass", cutoffHz: 105.11, linearGain: 0.25 },
					],
					effects: [
						"panning",
						"transition type",
						"note filter",
						"chorus",
						"echo",
						"reverb",
					],
					transition: "normal",
					clicklessTransition: false,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 6727.17, linearGain: 0.3536 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 6727.17, linearGain: 0.3536 }],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 1189.21, linearGain: 0.5 }],
					pan: 0,
					panDelay: 0,
					chorus: 14,
					echoSustain: 86,
					echoDelayBeats: 0.75,
					reverb: 13,
					fadeInSeconds: 0,
					fadeOutTicks: 24,
					wave: "1/4 pulse",
					unison: "hum",
					customChipWave: {
						"0": -13,
						"1": -6,
						"2": -17,
						"3": 1,
						"4": -9,
						"5": 9,
						"6": -2,
						"7": -12,
						"8": 6,
						"9": -5,
						"10": 13,
						"11": 3,
						"12": -8,
						"13": 10,
						"14": 0,
						"15": 18,
						"16": 7,
						"17": 2,
						"18": -4,
						"19": -14,
						"20": 4,
						"21": -7,
						"22": -18,
						"23": 0,
						"24": -10,
						"25": 8,
						"26": -3,
						"27": -13,
						"28": 5,
						"29": -6,
						"30": 12,
						"31": 2,
						"32": 20,
						"33": 9,
						"34": -1,
						"35": -6,
						"36": -12,
						"37": -23,
						"38": -5,
						"39": -15,
						"40": 3,
						"41": -8,
						"42": -19,
						"43": -1,
						"44": -11,
						"45": 7,
						"46": -4,
						"47": 14,
						"48": 4,
						"49": -7,
						"50": 11,
						"51": 1,
						"52": 19,
						"53": 8,
						"54": 3,
						"55": -3,
						"56": -13,
						"57": -24,
						"58": -6,
						"59": -17,
						"60": 2,
						"61": -9,
						"62": 9,
						"63": -2,
					},
					customChipWaveIntegral: {
						"0": 0,
						"1": 0,
						"2": 0,
						"3": 0,
						"4": 0,
						"5": 0,
						"6": 0,
						"7": 0,
						"8": 0,
						"9": 0,
						"10": 0,
						"11": 0,
						"12": 0,
						"13": 0,
						"14": 0,
						"15": 0,
						"16": 0,
						"17": 0,
						"18": 0,
						"19": 0,
						"20": 0,
						"21": 0,
						"22": 0,
						"23": 0,
						"24": 0,
						"25": 0,
						"26": 0,
						"27": 0,
						"28": 0,
						"29": 0,
						"30": 0,
						"31": 0,
						"32": 0,
						"33": 0,
						"34": 0,
						"35": 0,
						"36": 0,
						"37": 0,
						"38": 0,
						"39": 0,
						"40": 0,
						"41": 0,
						"42": 0,
						"43": 0,
						"44": 0,
						"45": 0,
						"46": 0,
						"47": 0,
						"48": 0,
						"49": 0,
						"50": 0,
						"51": 0,
						"52": 0,
						"53": 0,
						"54": 0,
						"55": 0,
						"56": 0,
						"57": 0,
						"58": 0,
						"59": 0,
						"60": 0,
						"61": 0,
						"62": 0,
						"63": 0,
						"64": 0,
					},
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "punch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
					isDrum: false,
				},
			},
			// Jukebox 0.1.0
			{
				name: "Portal Bass",
				generalMidi: false,
				tags: ["pickedstring", "cooltasdude", "featured"],
				settings: {
					type: "Picked String",
					volume: 0,
					eqFilter: [{ type: "low-pass", cutoffHz: 8000, linearGain: 0.5 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 8000, linearGain: 0.5 }],
					effects: ["panning", "note filter", "chorus", "reverb"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 1414.21, linearGain: 0.5 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 1414.21, linearGain: 0.5 }],
					pan: 0,
					panDelay: 10,
					chorus: 86,
					reverb: 13,
					fadeInSeconds: 0,
					fadeOutTicks: 6,
					harmonics: [
						86, 71, 71, 86, 100, 71, 71, 71, 57, 43, 29, 29, 14, 14, 14, 14, 14, 14, 0,
						14, 14, 14, 0, 0, 0, 0, 0, 0,
					],
					unison: "none",
					stringSustain: 93,
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "panning",
							envelope: "lfo",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 2,
							discrete: false,
							waveform: 0,
							steps: 2,
						},
					],
					isDrum: false,
				},
			},
			{
				name: "Warped Trumpet",
				generalMidi: false,
				tags: ["fm", "fm4op", "cooltasdude"],
				settings: {
					type: "FM",
					volume: 0,
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: ["panning", "pitch shift", "note filter", "chorus", "echo", "reverb"],
					pitchShiftSemitones: 11,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 2378.41, linearGain: 0.3536 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 2378.41, linearGain: 0.3536 }],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 9513.66, linearGain: 0.5 }],
					pan: 0,
					panDelay: 10,
					chorus: 100,
					echoSustain: 86,
					echoDelayBeats: 1,
					reverb: 0,
					fadeInSeconds: 0,
					fadeOutTicks: 48,
					algorithm: "(1 2 3)←4",
					feedbackType: "1→2→3→4",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "1×", amplitude: 9, waveform: "sine", pulseWidth: 5 },
						{ frequency: "4×", amplitude: 9, waveform: "sine", pulseWidth: 5 },
						{ frequency: "~4×", amplitude: 5, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 7, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 8,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "feedbackAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "pitchShift",
							envelope: "linear",
							inverse: false,
							perEnvelopeSpeed: 128,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
					isDrum: false,
				},
			},
			{
				name: "Minecraft Lead",
				generalMidi: false,
				tags: ["fm", "fm4op", "cooltasdude"],
				settings: {
					type: "FM",
					volume: 0,
					eqFilter: [
						{ type: "low-pass", cutoffHz: 9513.66, linearGain: 0.3536 },
						{
							type: "high-pass",
							cutoffHz: 2000,
							linearGain: 0.1768,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 9513.66, linearGain: 0.3536 },
						{
							type: "high-pass",
							cutoffHz: 2000,
							linearGain: 0.1768,
						},
					],
					effects: ["panning", "transition type", "bitcrusher", "chorus", "reverb"],
					transition: "slide",
					clicklessTransition: false,
					bitcrusherOctave: 5,
					bitcrusherQuantization: 86,
					pan: 0,
					panDelay: 10,
					chorus: 100,
					reverb: 39,
					fadeInSeconds: 0.0125,
					fadeOutTicks: 72,
					algorithm: "(1 2 3)←4",
					feedbackType: "1⟲ 2⟲ 3⟲ 4⟲",
					feedbackAmplitude: 5,
					operators: [
						{ frequency: "1×", amplitude: 10, waveform: "sine", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 8, waveform: "sine", pulseWidth: 5 },
						{ frequency: "3×", amplitude: 7, waveform: "sine", pulseWidth: 5 },
						{ frequency: "11×", amplitude: 2, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "none",
							envelope: "rise",
							inverse: false,
							perEnvelopeSpeed: 4,
							perEnvelopeLowerBound: 0.2,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "none",
							envelope: "swell",
							inverse: false,
							perEnvelopeSpeed: 8,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "chorus",
							envelope: "rise",
							inverse: false,
							perEnvelopeSpeed: 40,
							perEnvelopeLowerBound: 0.2,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "noteVolume",
							envelope: "linear",
							inverse: false,
							perEnvelopeSpeed: 4,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
					isDrum: false,
				},
			},
			{
				name: "Pulse Piano",
				generalMidi: false,
				tags: ["fm", "fm6op", "cooltasdude"],
				settings: {
					type: "FM6op",
					volume: 0,
					eqFilter: [
						{ type: "low-pass", cutoffHz: 5656.85, linearGain: 1 },
						{
							type: "peak",
							cutoffHz: 2000,
							linearGain: 0.25,
						},
						{ type: "peak", cutoffHz: 840.9, linearGain: 0.7071 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 5656.85, linearGain: 1 },
						{
							type: "peak",
							cutoffHz: 2000,
							linearGain: 0.25,
						},
						{ type: "peak", cutoffHz: 840.9, linearGain: 0.7071 },
					],
					effects: ["panning", "note filter", "chorus", "reverb"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 9513.66, linearGain: 0.1768 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 9513.66, linearGain: 0.1768 }],
					pan: 0,
					panDelay: 0,
					chorus: 43,
					reverb: 42,
					fadeInSeconds: 0,
					fadeOutTicks: 24,
					algorithm: "1 2 3 4 5 6",
					feedbackType: "1→5 2→6 3→4",
					feedbackAmplitude: 7,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "pulse width", pulseWidth: 2 },
						{
							frequency: "0.25×",
							amplitude: 14,
							waveform: "quasi-sine",
							pulseWidth: 5,
						},
						{ frequency: "0.75×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 14, waveform: "ramp", pulseWidth: 5 },
						{
							frequency: "0.5×",
							amplitude: 15,
							waveform: "pulse width",
							pulseWidth: 3,
						},
						{
							frequency: "0.25×",
							amplitude: 15,
							waveform: "pulse width",
							pulseWidth: 4,
						},
					],
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 2.25,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
					isDrum: false,
				},
			},
			{
				name: "Bouncy Goober",
				generalMidi: false,
				tags: ["pwm", "cooltasdude"],
				settings: {
					type: "PWM",
					volume: 0,
					eqFilter: [
						{ type: "low-pass", cutoffHz: 9513.66, linearGain: 0.1768 },
						{ type: "peak", cutoffHz: 297.3, linearGain: 1 },
						{ type: "peak", cutoffHz: 1189.21, linearGain: 2 },
						{ type: "peak", cutoffHz: 420.45, linearGain: 0.5 },
						{ type: "high-pass", cutoffHz: 105.11, linearGain: 0.5 },
						{ type: "peak", cutoffHz: 16000, linearGain: 2 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 9513.66, linearGain: 0.1768 },
						{ type: "peak", cutoffHz: 297.3, linearGain: 1 },
						{ type: "peak", cutoffHz: 1189.21, linearGain: 2 },
						{ type: "peak", cutoffHz: 420.45, linearGain: 0.5 },
						{ type: "high-pass", cutoffHz: 105.11, linearGain: 0.5 },
						{ type: "peak", cutoffHz: 16000, linearGain: 2 },
					],
					effects: [
						"panning",
						"transition type",
						"pitch shift",
						"vibrato",
						"note filter",
						"distortion",
						"chorus",
						"reverb",
					],
					transition: "normal",
					clicklessTransition: false,
					pitchShiftSemitones: 12,
					vibrato: "custom",
					vibratoDepth: 0.44,
					vibratoDelay: 23,
					vibratoSpeed: 26,
					vibratoType: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 6727.17, linearGain: 1 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 6727.17, linearGain: 1 }],
					distortion: 43,
					aliases: false,
					pan: 0,
					panDelay: 10,
					chorus: 43,
					reverb: 32,
					fadeInSeconds: 0,
					fadeOutTicks: 24,
					unison: "none",
					pulseWidth: 10,
					decimalOffset: 0,
					envelopes: [
						{ target: "noteFilterFreq", envelope: "flare 1", index: 0 },
						{
							target: "noteFilterFreq",
							envelope: "flare 3",
							index: 0,
						},
					],
					isDrum: false,
				},
			},
			{
				name: "Enwanken",
				generalMidi: false,
				tags: ["pwm", "cooltasdude"],
				settings: {
					type: "PWM",
					volume: 0,
					eqFilter: [
						{ type: "low-pass", cutoffHz: 4000, linearGain: 0.7071 },
						{
							type: "peak",
							cutoffHz: 1681.79,
							linearGain: 0.5,
						},
						{ type: "peak", cutoffHz: 5656.85, linearGain: 0.25 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 4000, linearGain: 0.7071 },
						{
							type: "peak",
							cutoffHz: 1681.79,
							linearGain: 0.5,
						},
						{ type: "peak", cutoffHz: 5656.85, linearGain: 0.25 },
					],
					effects: ["panning", "vibrato", "note filter", "chorus", "reverb"],
					vibrato: "shaky",
					vibratoDepth: 0.1,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 1,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 11313.71, linearGain: 2 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 11313.71, linearGain: 2 }],
					pan: 0,
					panDelay: 0,
					chorus: 100,
					reverb: 3,
					fadeInSeconds: 0.0263,
					fadeOutTicks: -6,
					pulseWidth: 46,
					decimalOffset: 0,
					unison: "none",
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "rise",
							inverse: false,
							perEnvelopeSpeed: 128,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "pulseWidth",
							envelope: "punch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 0.9,
							discrete: false,
						},
					],
					isDrum: false,
				},
			},
			{
				name: "Ancient Keyboard",
				generalMidi: false,
				tags: ["fm", "fm6op", "cooltasdude"],
				settings: {
					type: "FM6op",
					volume: 0,
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					eqSubFilters1: [],
					effects: ["panning", "chord type", "note filter", "echo", "reverb"],
					chord: "strum",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					monoChordTone: 1,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "peak", cutoffHz: 1681.79, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 2378.41, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 1189.21, linearGain: 0.0884 },
						{ type: "low-pass", cutoffHz: 5656.85, linearGain: 1 },
					],
					noteSubFilters0: [
						{ type: "peak", cutoffHz: 1681.79, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 2378.41, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 1189.21, linearGain: 0.0884 },
						{ type: "low-pass", cutoffHz: 5656.85, linearGain: 1 },
					],
					pan: 0,
					panDelay: 10,
					echoSustain: 86,
					echoDelayBeats: 0.5,
					reverb: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -6,
					algorithm: "Custom",
					feedbackType: "1⟲ 2⟲ 3⟲ 4⟲",
					feedbackAmplitude: 0,
					customAlgorithm: { mods: [[5], [5], [], [], [6], []], carrierCount: 5 },
					operators: [
						{
							frequency: "0.75×",
							amplitude: 15,
							waveform: "pulse width",
							pulseWidth: 3,
						},
						{ frequency: "1×", amplitude: 15, waveform: "pulse width", pulseWidth: 7 },
						{ frequency: "0.12×", amplitude: 14, waveform: "sine", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 15, waveform: "trapezoid", pulseWidth: 5 },
						{ frequency: "4×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 12, waveform: "sawtooth", pulseWidth: 5 },
					],
					envelopes: [],
					isDrum: false,
				},
			},
			// Jukebox 0.1.6
			{
				name: "Gleeful Saw",
				generalMidi: false,
				tags: ["chip", "chipwave", "cooltasdude"],
				settings: {
					type: "chip",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 4756.83, linearGain: 1.4142 },
						{
							type: "peak",
							cutoffHz: 2828.43,
							linearGain: 1.4142,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 4756.83, linearGain: 1.4142 },
						{
							type: "peak",
							cutoffHz: 2828.43,
							linearGain: 1.4142,
						},
					],
					eqSubFilters1: [
						{ type: "low-pass", cutoffHz: 4756.83, linearGain: 1.4142 },
						{
							type: "peak",
							cutoffHz: 2828.43,
							linearGain: 1.4142,
						},
					],
					effects: ["vibrato", "chorus", "reverb"],
					vibrato: "light",
					vibratoDepth: 0.15,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 0,
					panDelay: 10,
					chorus: 100,
					reverb: 0,
					fadeInSeconds: 0.0125,
					fadeOutTicks: 72,
					wave: "double saw",
					unison: "none",
					isUsingAdvancedLoopControls: false,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 16,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [],
				},
			},
			{
				name: "Manual Kick",
				generalMidi: false,
				tags: ["fm", "fm4op", "cooltasdude"],
				settings: {
					type: "FM",
					eqFilter: [{ type: "low-pass", cutoffHz: 4756.83, linearGain: 2 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 4756.83, linearGain: 2 }],
					eqSubFilters1: [{ type: "low-pass", cutoffHz: 1414.21, linearGain: 0.5 }],
					eqSubFilters2: [{ type: "low-pass", cutoffHz: 4756.83, linearGain: 2 }],
					effects: ["chord type", "note filter", "reverb"],
					chord: "strum",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					monoChordTone: 1,
					noteFilterType: true,
					noteSimpleCut: 7,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 13454.34, linearGain: 0.25 }],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 13454.34, linearGain: 0.25 }],
					panDelay: 10,
					reverb: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -3,
					algorithm: "1←3 2←4",
					feedbackType: "3⟲",
					feedbackAmplitude: 15,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "4×", amplitude: 6, waveform: "sine", pulseWidth: 5 },
						{ frequency: "~2×", amplitude: 3, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 6, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "feedbackAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 8,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Rounded Spike Pad",
				generalMidi: false,
				tags: ["chip", "chipwave", "cooltasdude", "pad"],
				settings: {
					type: "chip",
					eqFilter: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.7071 }],
					eqFilterType: true,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters1: [],
					effects: ["chord type", "vibrato", "chorus", "echo", "reverb"],
					chord: "strum",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					monoChordTone: 1,
					vibrato: "shaky",
					vibratoDepth: 0.1,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 1,
					panDelay: 0,
					chorus: 86,
					echoSustain: 0,
					echoDelayBeats: 0.167,
					reverb: 65,
					fadeInSeconds: 0.0125,
					fadeOutTicks: 48,
					wave: "spiky",
					unison: "vibrate",
					isUsingAdvancedLoopControls: false,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 6,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [],
				},
			},
			{
				name: "Singing Triangle",
				generalMidi: false,
				tags: ["chip", "chipwave", "cooltasdude"],
				settings: {
					type: "chip",
					eqFilter: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.7071 }],
					eqFilterType: true,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters1: [],
					effects: ["pitch shift", "chorus"],
					pitchShiftSemitones: 11,
					panDelay: 0,
					chorus: 29,
					fadeInSeconds: 0.0125,
					fadeOutTicks: 6,
					wave: "lemmbox HD triangle",
					unison: "none",
					isUsingAdvancedLoopControls: false,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 1000,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [
						{
							target: "pitchShift",
							envelope: "lfo",
							inverse: false,
							perEnvelopeSpeed: 256,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							waveform: 6,
							steps: 4,
						},
					],
				},
			},
			{
				name: "Surreal String Pad",
				generalMidi: false,
				tags: ["fm", "fm6op", "cooltasdude", "string", "pad"],
				settings: {
					type: "FM6op",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 8000, linearGain: 2 },
						{
							type: "high-pass",
							cutoffHz: 353.55,
							linearGain: 1,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 8000, linearGain: 2 },
						{
							type: "high-pass",
							cutoffHz: 353.55,
							linearGain: 1,
						},
					],
					effects: ["transition type", "note filter", "chorus", "echo", "reverb"],
					transition: "normal",
					clicklessTransition: false,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [],
					noteSubFilters0: [],
					panDelay: 0,
					chorus: 71,
					echoSustain: 86,
					echoDelayBeats: 1.083,
					reverb: 16,
					fadeInSeconds: 0.0125,
					fadeOutTicks: 12,
					algorithm: "Custom",
					feedbackType: "1⟲ 2⟲ 3⟲ 4⟲",
					feedbackAmplitude: 10,
					customAlgorithm: { mods: [[2, 3, 4], [], [], [], [], []], carrierCount: 6 },
					operators: [
						{ frequency: "1×", amplitude: 14, waveform: "quasi-sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 10, waveform: "sine", pulseWidth: 5 },
						{ frequency: "4×", amplitude: 13, waveform: "sine", pulseWidth: 5 },
						{ frequency: "8×", amplitude: 9, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [],
				},
			},
			{
				name: "Microwave Bass",
				generalMidi: false,
				tags: ["fm", "fm6op", "cooltasdude"],
				settings: {
					type: "FM6op",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: ["note filter"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 13454.34, linearGain: 0.25 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 13454.34, linearGain: 0.25 }],
					panDelay: 10,
					fadeInSeconds: 0,
					fadeOutTicks: -6,
					algorithm: "1←2←3←4←5←6",
					feedbackType: "1⟲",
					feedbackAmplitude: 5,
					operators: [
						{ frequency: "1×", amplitude: 12, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 6, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 9, waveform: "sine", pulseWidth: 5 },
						{ frequency: "16×", amplitude: 6, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [],
				},
			},
			{
				name: "Cartoon Pulse",
				generalMidi: false,
				tags: ["fm", "fm6op", "cooltasdude"],
				settings: {
					type: "FM6op",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					eqSubFilters1: [],
					effects: ["note filter", "reverb"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 2378.41, linearGain: 1.4142 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 2378.41, linearGain: 1.4142 }],
					panDelay: 0,
					reverb: 23,
					fadeInSeconds: 0,
					fadeOutTicks: -6,
					algorithm: "1←3 2←4←(5 6)",
					feedbackType: "1⟲ 2⟲ 3⟲",
					feedbackAmplitude: 5,
					operators: [
						{ frequency: "~2×", amplitude: 13, waveform: "ramp", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 12, waveform: "trapezoid", pulseWidth: 5 },
						{ frequency: "0.75×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "trapezoid", pulseWidth: 5 },
						{ frequency: "0.75×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "operatorAmplitude",
							envelope: "wibble",
							inverse: false,
							perEnvelopeSpeed: 5.5,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 2,
						},
						{
							target: "operatorFrequency",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 18,
							perEnvelopeLowerBound: 0.9,
							perEnvelopeUpperBound: 1.8,
							discrete: false,
							index: 4,
						},
						{
							target: "feedbackAmplitude",
							envelope: "decay",
							inverse: false,
							perEnvelopeSpeed: 40,
							perEnvelopeLowerBound: 0.7,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Sunrise Guitar",
				generalMidi: false,
				tags: ["chip", "customchip", "cooltasdude", "chiptune"],
				settings: {
					type: "custom chip",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 3363.59, linearGain: 5.6569 },
						{
							type: "high-pass",
							cutoffHz: 1000,
							linearGain: 0.25,
						},
						{ type: "peak", cutoffHz: 5656.85, linearGain: 1 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 3363.59, linearGain: 5.6569 },
						{
							type: "high-pass",
							cutoffHz: 1000,
							linearGain: 0.25,
						},
						{ type: "peak", cutoffHz: 5656.85, linearGain: 1 },
					],
					effects: [
						"chord type",
						"vibrato",
						"note filter",
						"distortion",
						"bitcrusher",
						"chorus",
						"reverb",
					],
					chord: "simultaneous",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					monoChordTone: 1,
					vibrato: "custom",
					vibratoDepth: 0.68,
					vibratoDelay: 22,
					vibratoSpeed: 10,
					vibratoType: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 1000, linearGain: 2.8284 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 1000, linearGain: 2.8284 }],
					distortion: 43,
					aliases: false,
					bitcrusherOctave: 6.5,
					bitcrusherQuantization: 0,
					panDelay: 10,
					chorus: 43,
					reverb: 13,
					fadeInSeconds: 0,
					fadeOutTicks: 24,
					wave: "triangle",
					unison: "none",
					customChipWave: {
						"0": 24,
						"1": 24,
						"2": 23,
						"3": 22,
						"4": 21,
						"5": 21,
						"6": 20,
						"7": 19,
						"8": 18,
						"9": 18,
						"10": 17,
						"11": 16,
						"12": 15,
						"13": 15,
						"14": 14,
						"15": 13,
						"16": 12,
						"17": 12,
						"18": 11,
						"19": 10,
						"20": 9,
						"21": 9,
						"22": 8,
						"23": 7,
						"24": 6,
						"25": 6,
						"26": 5,
						"27": 4,
						"28": 3,
						"29": 3,
						"30": 2,
						"31": 1,
						"32": 0,
						"33": 0,
						"34": -1,
						"35": -2,
						"36": -3,
						"37": -3,
						"38": -4,
						"39": -5,
						"40": -6,
						"41": -6,
						"42": -7,
						"43": -8,
						"44": -9,
						"45": -9,
						"46": -10,
						"47": -11,
						"48": -12,
						"49": -12,
						"50": -13,
						"51": -14,
						"52": -15,
						"53": -15,
						"54": -16,
						"55": -17,
						"56": -18,
						"57": -18,
						"58": -19,
						"59": -20,
						"60": -21,
						"61": -21,
						"62": -22,
						"63": -23,
					},
					customChipWaveIntegral: {
						"0": 0,
						"1": 0,
						"2": 0,
						"3": 0,
						"4": 0,
						"5": 0,
						"6": 0,
						"7": 0,
						"8": 0,
						"9": 0,
						"10": 0,
						"11": 0,
						"12": 0,
						"13": 0,
						"14": 0,
						"15": 0,
						"16": 0,
						"17": 0,
						"18": 0,
						"19": 0,
						"20": 0,
						"21": 0,
						"22": 0,
						"23": 0,
						"24": 0,
						"25": 0,
						"26": 0,
						"27": 0,
						"28": 0,
						"29": 0,
						"30": 0,
						"31": 0,
						"32": 0,
						"33": 0,
						"34": 0,
						"35": 0,
						"36": 0,
						"37": 0,
						"38": 0,
						"39": 0,
						"40": 0,
						"41": 0,
						"42": 0,
						"43": 0,
						"44": 0,
						"45": 0,
						"46": 0,
						"47": 0,
						"48": 0,
						"49": 0,
						"50": 0,
						"51": 0,
						"52": 0,
						"53": 0,
						"54": 0,
						"55": 0,
						"56": 0,
						"57": 0,
						"58": 0,
						"59": 0,
						"60": 0,
						"61": 0,
						"62": 0,
						"63": 0,
						"64": 0,
					},
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "rise",
							inverse: false,
							perEnvelopeSpeed: 0.3333,
							perEnvelopeLowerBound: 0.8,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "noteVolume",
							envelope: "note size",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "distortion",
							envelope: "note size",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Supersaw Kick",
				generalMidi: false,
				tags: ["supersaw", "cooltasdude", "kick"],
				settings: {
					type: "supersaw",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 4,
					eqSubFilters0: [],
					effects: ["pitch shift", "note filter"],
					pitchShiftSemitones: 24,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [],
					noteSubFilters0: [],
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					pulseWidth: 50,
					decimalOffset: 0,
					dynamism: 100,
					spread: 50,
					shape: 0,
					envelopes: [
						{
							target: "pitchShift",
							envelope: "fall",
							inverse: false,
							perEnvelopeSpeed: 256,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "noteVolume",
							envelope: "fall",
							inverse: false,
							perEnvelopeSpeed: 64,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Choral Ghost",
				generalMidi: false,
				tags: ["supersaw", "cooltasdude"],
				settings: {
					type: "supersaw",
					eqFilter: [{ type: "low-pass", cutoffHz: 2378.41, linearGain: 0.5 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 2378.41, linearGain: 0.5 }],
					effects: ["vibrato", "note filter", "chorus", "reverb"],
					vibrato: "shaky",
					vibratoDepth: 0.1,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 1,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 1000, linearGain: 0.7071 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 1000, linearGain: 0.7071 }],
					panDelay: 0,
					chorus: 0,
					reverb: 90,
					fadeInSeconds: 0.0125,
					fadeOutTicks: 12,
					pulseWidth: 46,
					decimalOffset: 0,
					dynamism: 100,
					spread: 17,
					shape: 83,
					envelopes: [],
				},
			},
			// JukeBox 0.2.1
			{
				name: "Highest Pulse",
				generalMidi: false,
				tags: ["pwm", "cooltasdude"],
				settings: {
					type: "PWM",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 4,
					eqSubFilters0: [],
					eqSubFilters1: [],
					effects: ["note filter", "chorus", "reverb"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 3363.59, linearGain: 2.8284 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 3363.59, linearGain: 2.8284 }],
					panDelay: 0,
					chorus: 100,
					reverb: 3,
					fadeInSeconds: 0,
					fadeOutTicks: -3,
					pulseWidth: 49,
					decimalOffset: 0,
					unison: "vibrate",
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "swell",
							inverse: false,
							perEnvelopeSpeed: 1.25,
							perEnvelopeLowerBound: 0.1,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			// -------------JukeBox 0.2.3--------------
			{
				name: "Construct Flare",
				generalMidi: false,
				tags: ["supersaw", "cooltasdude"],
				settings: {
					type: "supersaw",
					eqFilter: [
						{ type: "peak", cutoffHz: 1414.21, linearGain: 2 },
						{
							type: "peak",
							cutoffHz: 1189.21,
							linearGain: 2,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 10,
					eqSubFilters0: [
						{ type: "peak", cutoffHz: 1414.21, linearGain: 2 },
						{
							type: "peak",
							cutoffHz: 1189.21,
							linearGain: 2,
						},
					],
					effects: ["vibrato", "note filter", "echo", "reverb"],
					vibrato: "delayed",
					vibratoDepth: 0.3,
					vibratoDelay: 18.5,
					vibratoSpeed: 10,
					vibratoType: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 11313.71, linearGain: 1.4142 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 11313.71, linearGain: 1.4142 }],
					panDelay: 10,
					echoSustain: 57,
					echoDelayBeats: 0.833,
					reverb: 32,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					pulseWidth: 49,
					decimalOffset: 0,
					dynamism: 33,
					spread: 58,
					shape: 17,
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "swell",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "pulseWidth",
							envelope: "decay",
							inverse: false,
							perEnvelopeSpeed: 7,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Warped Trumpet 2",
				generalMidi: false,
				tags: ["fm", "fm6op", "cooltasdude", "featured"],
				settings: {
					type: "FM6op",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 20,
					eqSubFilters0: [],
					effects: ["pitch shift", "note filter", "granular", "chorus", "echo", "reverb"],
					pitchShiftSemitones: 11,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 2378.41, linearGain: 0.3536 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 2378.41, linearGain: 0.3536 }],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 9513.66, linearGain: 0.5 }],
					granular: 2,
					grainSize: 10,
					grainAmounts: 4,
					grainRange: 0,
					panDelay: 10,
					chorus: 29,
					echoSustain: 86,
					echoDelayBeats: 1.083,
					reverb: 0,
					fadeInSeconds: 0,
					fadeOutTicks: 48,
					algorithm: "Custom",
					feedbackType: "1⟲",
					feedbackAmplitude: 5,
					customAlgorithm: {
						mods: [[2, 3, 6, 5, 4], [4], [4], [], [], []],
						carrierCount: 4,
					},
					operators: [
						{ frequency: "~1×", amplitude: 13, waveform: "pulse width", pulseWidth: 5 },
						{ frequency: "4×", amplitude: 13, waveform: "sine", pulseWidth: 5 },
						{ frequency: "~4×", amplitude: 10, waveform: "sine", pulseWidth: 5 },
						{ frequency: "4×", amplitude: 15, waveform: "half-sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 7, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 4,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "feedbackAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 16,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "pitchShift",
							envelope: "linear",
							inverse: false,
							perEnvelopeSpeed: 64,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "operatorAmplitude",
							envelope: "rise",
							inverse: false,
							perEnvelopeSpeed: 9.5,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 5,
						},
						{
							target: "operatorAmplitude",
							envelope: "lfo",
							inverse: false,
							perEnvelopeSpeed: 0.06,
							perEnvelopeLowerBound: 0.8,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 3,
							waveform: 0,
							steps: 2,
						},
						{
							target: "operatorAmplitude",
							envelope: "lfo",
							inverse: false,
							perEnvelopeSpeed: 0.05,
							perEnvelopeLowerBound: 0.8,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 0,
							waveform: 0,
							steps: 2,
						},
					],
				},
			},
			// this was NOT submitted through the form
			{
				name: "False Square 2",
				generalMidi: false,
				tags: ["fm", "fm6op", "cooltasdude"],
				settings: {
					type: "FM6op",
					eqFilter: [{ type: "high-pass", cutoffHz: 250, linearGain: 1 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "high-pass", cutoffHz: 250, linearGain: 1 }],
					eqSubFilters1: [],
					effects: ["chord type", "chorus", "echo", "reverb"],
					chord: "strum",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					monoChordTone: 1,
					panDelay: 0,
					chorus: 57,
					echoSustain: 43,
					echoDelayBeats: 1,
					reverb: 52,
					fadeInSeconds: 0,
					fadeOutTicks: -3,
					algorithm: "Custom",
					feedbackType: "1⟲ 2⟲ 3⟲",
					feedbackAmplitude: 5,
					customAlgorithm: { mods: [[2, 3], [], [], [], [], []], carrierCount: 1 },
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "camelsine", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 7, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "3×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "16×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "0.5×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "operatorAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 256,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 2,
						},
						{
							target: "noteVolume",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 3,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			// -------------JukeBox 0.3.0--------------
			{
				name: "Agony Saw",
				generalMidi: false,
				tags: ["chip", "chipwave", "cooltasdude"],
				settings: {
					type: "chip",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 13454.34, linearGain: 1.4142 },
						{
							type: "high-pass",
							cutoffHz: 500,
							linearGain: 2.8284,
						},
						{ type: "peak", cutoffHz: 1000, linearGain: 2 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 13454.34, linearGain: 1.4142 },
						{
							type: "high-pass",
							cutoffHz: 500,
							linearGain: 2.8284,
						},
						{ type: "peak", cutoffHz: 1000, linearGain: 2 },
					],
					effects: [
						"note filter",
						"granular",
						"distortion",
						"chorus",
						"echo",
						"reverb",
						"ring mod",
					],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "peak", cutoffHz: 176.78, linearGain: 5.6569 },
						{
							type: "low-pass",
							cutoffHz: 9513.66,
							linearGain: 1.4142,
						},
					],
					noteSubFilters0: [
						{ type: "peak", cutoffHz: 176.78, linearGain: 5.6569 },
						{
							type: "low-pass",
							cutoffHz: 9513.66,
							linearGain: 1.4142,
						},
					],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 1000, linearGain: 2 }],
					granular: 2,
					grainSize: 49,
					grainAmounts: 2,
					grainRange: 40,
					ringMod: 29,
					ringModHz: 51,
					ringModWaveformIndex: 5,
					ringModPulseWidth: 10,
					ringModHzOffset: 50,
					distortion: 29,
					aliases: false,
					panDelay: 0,
					chorus: 43,
					echoSustain: 29,
					echoDelayBeats: 1.167,
					reverb: 58,
					fadeInSeconds: 0.0125,
					fadeOutTicks: -1,
					wave: "double saw",
					unison: "none",
					isUsingAdvancedLoopControls: false,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 16,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [
						{
							target: "grainSize",
							envelope: "fall",
							inverse: false,
							perEnvelopeSpeed: 2,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "echoDelay",
							envelope: "blip",
							inverse: false,
							perEnvelopeSpeed: 6,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "echoDelay",
							envelope: "rise",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			// { name: "", generalMidi: false, tags:["", "cooltasdude"], settings: {} },
			// { name: "", generalMidi: false, tags:["", "cooltasdude"], settings: {} },
		]),
	},
];
